import React from 'react'

const DentalRecord1 = (props) => {
  return(
  <svg id="svg-dr" height="340" width="1200">
  <g>
  <line x1="372" y1="0" x2="372" y2="340" style={{stroke: "grey"}}/>
  <line x1="827" y1="0" x2="827" y2="340" style={{stroke: "grey"}}/>
  </g>
  <g transform="translate(290,0)" {...props.settings.q1btn}><rect width="35" height="25" fill="white"/> <rect x="0.1" y="0.1" width="34.8" height="24.8" rx="1.9" fill="#EEEEEE" stroke="#C4C4C4" strokeWidth="0.2"/> <path d="M17.6016 12.6201C17.6016 13.4961 17.4619 14.2557 17.1826 14.8989C16.9076 15.5379 16.5203 16.0457 16.021 16.4224L17.6079 17.6602L16.5669 18.5996L14.5991 17.0444C14.341 17.0994 14.0638 17.127 13.7676 17.127C13.0228 17.127 12.3563 16.945 11.7681 16.5811C11.1841 16.2129 10.7313 15.6903 10.4097 15.0132C10.0923 14.3361 9.93148 13.5553 9.92725 12.6709V12.1504C9.92725 11.249 10.0859 10.4535 10.4033 9.76367C10.7249 9.07389 11.1756 8.54704 11.7554 8.18311C12.3394 7.81494 13.0059 7.63086 13.7549 7.63086C14.5166 7.63086 15.1873 7.81283 15.7671 8.17676C16.3511 8.53646 16.8018 9.05697 17.1191 9.73828C17.4365 10.4154 17.5973 11.2046 17.6016 12.106V12.6201ZM15.9893 12.1377C15.9893 11.0967 15.7946 10.3075 15.4053 9.77002C15.016 9.23258 14.4658 8.96387 13.7549 8.96387C13.0651 8.96387 12.5234 9.23682 12.1299 9.78271C11.7406 10.3244 11.5417 11.0903 11.5332 12.0806V12.6201C11.5332 13.6188 11.7279 14.3996 12.1172 14.9624C12.5107 15.5252 13.0609 15.8066 13.7676 15.8066C14.4827 15.8066 15.0308 15.5358 15.4116 14.9941C15.7967 14.4525 15.9893 13.6611 15.9893 12.6201V12.1377ZM23.1621 17H21.626V9.57959L19.3599 10.354V9.05273L22.9653 7.72607H23.1621V17Z" fill="#4D4D4D"/> </g>
  <g transform="translate(584,0)" {...props.settings.ubtn}><rect width="35" height="25" fill="white"/> <rect x="0.1" y="0.1" width="34.8" height="24.8" rx="1.9" fill="#EEEEEE" stroke="#C4C4C4" strokeWidth="0.2"/> <path d="M20.9595 7.75781V13.9341C20.9595 14.9159 20.6442 15.6945 20.0137 16.27C19.3874 16.8413 18.5516 17.127 17.5063 17.127C16.4484 17.127 15.6084 16.8455 14.9863 16.2827C14.3643 15.7157 14.0532 14.9307 14.0532 13.9277V7.75781H15.6528V13.9404C15.6528 14.5583 15.8094 15.0301 16.1226 15.356C16.4357 15.6818 16.897 15.8447 17.5063 15.8447C18.742 15.8447 19.3599 15.193 19.3599 13.8896V7.75781H20.9595Z" fill="#4D4D4D"/> </g>
  <g transform="translate(875,0)" {...props.settings.q2btn}><rect width="35" height="25" fill="white"/> <rect x="0.1" y="0.1" width="34.8" height="24.8" rx="1.9" fill="#EEEEEE" stroke="#C4C4C4" strokeWidth="0.2"/> <path d="M17.6016 12.6201C17.6016 13.4961 17.4619 14.2557 17.1826 14.8989C16.9076 15.5379 16.5203 16.0457 16.021 16.4224L17.6079 17.6602L16.5669 18.5996L14.5991 17.0444C14.341 17.0994 14.0638 17.127 13.7676 17.127C13.0228 17.127 12.3563 16.945 11.7681 16.5811C11.1841 16.2129 10.7313 15.6903 10.4097 15.0132C10.0923 14.3361 9.93148 13.5553 9.92725 12.6709V12.1504C9.92725 11.249 10.0859 10.4535 10.4033 9.76367C10.7249 9.07389 11.1756 8.54704 11.7554 8.18311C12.3394 7.81494 13.0059 7.63086 13.7549 7.63086C14.5166 7.63086 15.1873 7.81283 15.7671 8.17676C16.3511 8.53646 16.8018 9.05697 17.1191 9.73828C17.4365 10.4154 17.5973 11.2046 17.6016 12.106V12.6201ZM15.9893 12.1377C15.9893 11.0967 15.7946 10.3075 15.4053 9.77002C15.016 9.23258 14.4658 8.96387 13.7549 8.96387C13.0651 8.96387 12.5234 9.23682 12.1299 9.78271C11.7406 10.3244 11.5417 11.0903 11.5332 12.0806V12.6201C11.5332 13.6188 11.7279 14.3996 12.1172 14.9624C12.5107 15.5252 13.0609 15.8066 13.7676 15.8066C14.4827 15.8066 15.0308 15.5358 15.4116 14.9941C15.7967 14.4525 15.9893 13.6611 15.9893 12.6201V12.1377ZM25.1997 17H18.9854V15.9399L22.064 12.582C22.5083 12.0869 22.8236 11.6743 23.0098 11.3442C23.2002 11.0099 23.2954 10.6756 23.2954 10.3413C23.2954 9.9012 23.1706 9.54574 22.9209 9.2749C22.6755 9.00407 22.3433 8.86865 21.9243 8.86865C21.425 8.86865 21.0378 9.021 20.7627 9.32568C20.4876 9.63037 20.3501 10.0472 20.3501 10.5762H18.8076C18.8076 10.0133 18.9346 9.50765 19.1885 9.05908C19.4466 8.60628 19.8127 8.25505 20.2866 8.00537C20.7648 7.7557 21.3149 7.63086 21.937 7.63086C22.8341 7.63086 23.5409 7.85726 24.0571 8.31006C24.5776 8.75863 24.8379 9.3807 24.8379 10.1763C24.8379 10.6375 24.7067 11.1221 24.4443 11.6299C24.1862 12.1335 23.7609 12.7069 23.1685 13.3501L20.9087 15.7686H25.1997V17Z" fill="#4D4D4D"/> </g>
  <g transform="translate(584,165)" {...props.settings.fmbtn}><rect width="35" height="25" fill="white"/> <rect x="0.1" y="0.1" width="34.8" height="24.8" rx="1.9" fill="#EEEEEE" stroke="#C4C4C4" strokeWidth="0.2"/> <path d="M14.9595 12.686H11.812V16H10.4531V8.17969H15.4214V9.27539H11.812V11.6011H14.9595V12.686ZM18.2627 8.17969L20.5186 14.1738L22.769 8.17969H24.5254V16H23.1719V13.4219L23.3062 9.97363L20.9966 16H20.0244L17.7202 9.979L17.8545 13.4219V16H16.501V8.17969H18.2627Z" fill="#4D4D4D"/> </g>
  <g transform="translate(290,315)" {...props.settings.q4btn}><rect width="35" height="25" fill="white"/> <rect x="0.1" y="0.1" width="34.8" height="24.8" rx="1.9" fill="#EEEEEE" stroke="#C4C4C4" strokeWidth="0.2"/> <path d="M17.6016 12.6201C17.6016 13.4961 17.4619 14.2557 17.1826 14.8989C16.9076 15.5379 16.5203 16.0457 16.021 16.4224L17.6079 17.6602L16.5669 18.5996L14.5991 17.0444C14.341 17.0994 14.0638 17.127 13.7676 17.127C13.0228 17.127 12.3563 16.945 11.7681 16.5811C11.1841 16.2129 10.7313 15.6903 10.4097 15.0132C10.0923 14.3361 9.93148 13.5553 9.92725 12.6709V12.1504C9.92725 11.249 10.0859 10.4535 10.4033 9.76367C10.7249 9.07389 11.1756 8.54704 11.7554 8.18311C12.3394 7.81494 13.0059 7.63086 13.7549 7.63086C14.5166 7.63086 15.1873 7.81283 15.7671 8.17676C16.3511 8.53646 16.8018 9.05697 17.1191 9.73828C17.4365 10.4154 17.5973 11.2046 17.6016 12.106V12.6201ZM15.9893 12.1377C15.9893 11.0967 15.7946 10.3075 15.4053 9.77002C15.016 9.23258 14.4658 8.96387 13.7549 8.96387C13.0651 8.96387 12.5234 9.23682 12.1299 9.78271C11.7406 10.3244 11.5417 11.0903 11.5332 12.0806V12.6201C11.5332 13.6188 11.7279 14.3996 12.1172 14.9624C12.5107 15.5252 13.0609 15.8066 13.7676 15.8066C14.4827 15.8066 15.0308 15.5358 15.4116 14.9941C15.7967 14.4525 15.9893 13.6611 15.9893 12.6201V12.1377ZM24.2031 13.7056H25.3521V14.9434H24.2031V17H22.6606V14.9434H18.668L18.6235 14.0039L22.6099 7.75781H24.2031V13.7056ZM20.2422 13.7056H22.6606V9.84619L22.5464 10.0493L20.2422 13.7056Z" fill="#4D4D4D"/> </g>
  <g transform="translate(584,315)"{...props.settings.lbtn}><rect width="35" height="25" fill="white"/> <rect x="0.1" y="0.1" width="34.8" height="24.8" rx="1.9" fill="#EEEEEE" stroke="#C4C4C4" strokeWidth="0.2"/> <path d="M16.5288 15.7178H20.7246V17H14.9229V7.75781H16.5288V15.7178Z" fill="#4D4D4D"/> </g>
  <g transform="translate(875,315)" {...props.settings.q3btn}><rect width="35" height="25" fill="white"/> <rect x="0.1" y="0.1" width="34.8" height="24.8" rx="1.9" fill="#EEEEEE" stroke="#C4C4C4" strokeWidth="0.2"/> <path d="M17.6016 12.6201C17.6016 13.4961 17.4619 14.2557 17.1826 14.8989C16.9076 15.5379 16.5203 16.0457 16.021 16.4224L17.6079 17.6602L16.5669 18.5996L14.5991 17.0444C14.341 17.0994 14.0638 17.127 13.7676 17.127C13.0228 17.127 12.3563 16.945 11.7681 16.5811C11.1841 16.2129 10.7313 15.6903 10.4097 15.0132C10.0923 14.3361 9.93148 13.5553 9.92725 12.6709V12.1504C9.92725 11.249 10.0859 10.4535 10.4033 9.76367C10.7249 9.07389 11.1756 8.54704 11.7554 8.18311C12.3394 7.81494 13.0059 7.63086 13.7549 7.63086C14.5166 7.63086 15.1873 7.81283 15.7671 8.17676C16.3511 8.53646 16.8018 9.05697 17.1191 9.73828C17.4365 10.4154 17.5973 11.2046 17.6016 12.106V12.6201ZM15.9893 12.1377C15.9893 11.0967 15.7946 10.3075 15.4053 9.77002C15.016 9.23258 14.4658 8.96387 13.7549 8.96387C13.0651 8.96387 12.5234 9.23682 12.1299 9.78271C11.7406 10.3244 11.5417 11.0903 11.5332 12.0806V12.6201C11.5332 13.6188 11.7279 14.3996 12.1172 14.9624C12.5107 15.5252 13.0609 15.8066 13.7676 15.8066C14.4827 15.8066 15.0308 15.5358 15.4116 14.9941C15.7967 14.4525 15.9893 13.6611 15.9893 12.6201V12.1377ZM20.769 11.6743H21.7085C22.1825 11.6701 22.557 11.5474 22.832 11.3062C23.1113 11.0649 23.251 10.7158 23.251 10.2588C23.251 9.81868 23.1346 9.47803 22.9019 9.23682C22.6733 8.99137 22.3221 8.86865 21.8481 8.86865C21.4334 8.86865 21.0928 8.98926 20.8262 9.23047C20.5596 9.46745 20.4263 9.77848 20.4263 10.1636H18.8838C18.8838 9.68962 19.0086 9.25798 19.2583 8.86865C19.5122 8.47933 19.8634 8.17676 20.312 7.96094C20.7648 7.74089 21.2705 7.63086 21.8291 7.63086C22.7516 7.63086 23.4753 7.86361 24 8.3291C24.529 8.79036 24.7935 9.43359 24.7935 10.2588C24.7935 10.6735 24.6602 11.0649 24.3936 11.4331C24.1312 11.797 23.7905 12.0721 23.3716 12.2583C23.8794 12.4318 24.2645 12.7048 24.5269 13.0771C24.7935 13.4495 24.9268 13.8939 24.9268 14.4102C24.9268 15.2396 24.6411 15.8997 24.0698 16.3906C23.5028 16.8815 22.7559 17.127 21.8291 17.127C20.9404 17.127 20.2126 16.89 19.6455 16.416C19.0785 15.9421 18.7949 15.3115 18.7949 14.5244H20.3374C20.3374 14.9307 20.4728 15.2607 20.7437 15.5146C21.0187 15.7686 21.3869 15.8955 21.8481 15.8955C22.3263 15.8955 22.703 15.7686 22.978 15.5146C23.2531 15.2607 23.3906 14.8926 23.3906 14.4102C23.3906 13.9235 23.2467 13.549 22.959 13.2866C22.6712 13.0243 22.2438 12.8931 21.6768 12.8931H20.769V11.6743Z" fill="#4D4D4D"/> </g>
    <circle
      id="T11-5"
      fill="white"
      stroke="black"
      cx={535} 
      cy={45}
      r={23}
      {...props.settings.T11C}
    />
    <circle
      id="T11-4"
      fill="white"
      stroke="black"
      cx={535} 
      cy={45}
      r={10}
      {...props.settings.T11I}
    />
       <>
      <rect id="T11-rs"
      x={494}
      y={33}
      width={16} 
      height={24}
      {...props.settings.TS11S12}  
      fill="white"
      stroke="none"
      /> 
      <circle
      id="T11-cs"
      stroke="black"
      cx={502}
      cy={45}
      r={8}
      {...props.settings.TS11S12}
      />
      <text 
        id="T11-ts"
        x={502}
        y={45}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS11S12t}
        >S</text></><>
      <circle
        id="T11-csn"
        stroke="black"
        cx={535}
        cy={12}
        r={8}
        {...props.settings.TS11La}
      />
      <text 
        id="T11-tsn"
        x={535}
        y={12}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS11Lat}
        >S</text>
      </><>
      <circle
        id="T11-css"
        stroke="black"
        cx={535}
        cy={78}
        r={8}
        {...props.settings.TS11Pa}
      />
      <text 
        id="T11-tss"
        x={535}
        y={78}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS11Pat}
        >S</text>
      </>
    <path
      id="T11-0"
      d={"M542.0710678118655,37.928932188134524 A10,10 0 0,0 527.9289321881346,37.928932188134524 L520.857864376269,30.85786437626905 A20,20 0 0,1 549.142135623731,30.85786437626905 L542.0710678118655,37.928932188134524"}
      fill="white"
      stroke="black"
      {...props.settings.T11La}
    />
    <path
      id="T11-1"
      d={"M527.9289321881346,37.928932188134524 A10,10 0 0,0 527.9289321881345,52.071067811865476 L520.857864376269,59.14213562373095 A20,20 0 0,1 520.857864376269,30.85786437626905 L527.9289321881346,37.928932188134524"}
      fill="white"
      stroke="black"
      {...props.settings.T11D}
    />
    <path
      id="T11-2"
      d={"M527.9289321881345,52.071067811865476 A10,10 0 0,0 542.0710678118654,52.071067811865476 L549.142135623731,59.14213562373095 A20,20 0 0,1 520.857864376269,59.14213562373095 L527.9289321881345,52.071067811865476"}
      fill="white"
      stroke="black"
      {...props.settings.T11Pa}
    />
    <path
      id="T11-3"
      d={"M542.0710678118654,52.071067811865476 A10,10 0 0,0 542.0710678118655,37.928932188134524 L549.142135623731,30.857864376269053 A20,20 0 0,1 549.142135623731,59.14213562373095 L542.0710678118654,52.071067811865476"}
      fill="white"
      stroke="black"
      {...props.settings.T11M}
    />
    {props.settings.T11?.implant && 
      <g>
      <image href="/static/images/implantTooth.png" x={503} y={13} height="65" width="65"/>
    </g>}

    <circle
      id="T12-5"
      fill="white"
      stroke="black"
      cx={470} 
      cy={45}
      r={23}
      {...props.settings.T12C}
    />
    <circle
      id="T12-4"
      fill="white"
      stroke="black"
      cx={470} 
      cy={45}
      r={10}
      {...props.settings.T12I}
    />
       <>
      <rect id="T12-rs"
      x={429}
      y={33}
      width={16} 
      height={24}
      {...props.settings.TS12S13}  
      fill="white"
      stroke="none"
      /> 
      <circle
      id="T12-cs"
      stroke="black"
      cx={437}
      cy={45}
      r={8}
      {...props.settings.TS12S13}
      />
      <text 
        id="T12-ts"
        x={437}
        y={45}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS12S13t}
        >S</text></><>
      <circle
        id="T12-csn"
        stroke="black"
        cx={470}
        cy={12}
        r={8}
        {...props.settings.TS12La}
      />
      <text 
        id="T12-tsn"
        x={470}
        y={12}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS12Lat}
        >S</text>
      </><>
      <circle
        id="T12-css"
        stroke="black"
        cx={470}
        cy={78}
        r={8}
        {...props.settings.TS12Pa}
      />
      <text 
        id="T12-tss"
        x={470}
        y={78}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS12Pat}
        >S</text>
      </>
    <path
      id="T12-0"
      d={"M477.0710678118655,37.928932188134524 A10,10 0 0,0 462.9289321881345,37.928932188134524 L455.85786437626905,30.85786437626905 A20,20 0 0,1 484.14213562373095,30.85786437626905 L477.0710678118655,37.928932188134524"}
      fill="white"
      stroke="black"
      {...props.settings.T12La}
    />
    <path
      id="T12-1"
      d={"M462.9289321881345,37.928932188134524 A10,10 0 0,0 462.9289321881345,52.071067811865476 L455.85786437626905,59.14213562373095 A20,20 0 0,1 455.85786437626905,30.85786437626905 L462.9289321881345,37.928932188134524"}
      fill="white"
      stroke="black"
      {...props.settings.T12D}
    />
    <path
      id="T12-2"
      d={"M462.9289321881345,52.071067811865476 A10,10 0 0,0 477.0710678118655,52.071067811865476 L484.14213562373095,59.14213562373095 A20,20 0 0,1 455.85786437626905,59.14213562373095 L462.9289321881345,52.071067811865476"}
      fill="white"
      stroke="black"
      {...props.settings.T12Pa}
    />
    <path
      id="T12-3"
      d={"M477.0710678118655,52.071067811865476 A10,10 0 0,0 477.0710678118655,37.928932188134524 L484.14213562373095,30.857864376269053 A20,20 0 0,1 484.14213562373095,59.14213562373095 L477.0710678118655,52.071067811865476"}
      fill="white"
      stroke="black"
      {...props.settings.T12M}
    />
    {props.settings.T12?.implant && 
      <g>
      <image href="/static/images/implantTooth.png" x={438} y={13} height="65" width="65"/>
    </g>}

    <circle
      id="T13-5"
      fill="white"
      stroke="black"
      cx={405} 
      cy={45}
      r={23}
      {...props.settings.T13C}
    />
    <circle
      id="T13-4"
      fill="white"
      stroke="black"
      cx={405} 
      cy={45}
      r={10}
      {...props.settings.T13I}
    />
       <>
      <rect id="T13-rs"
      x={364}
      y={33}
      width={16} 
      height={24}
      {...props.settings.TS13S14}  
      fill="white"
      stroke="none"
      /> 
      <circle
      id="T13-cs"
      stroke="black"
      cx={372}
      cy={45}
      r={8}
      {...props.settings.TS13S14}
      />
      <text 
        id="T13-ts"
        x={372}
        y={45}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS13S14t}
        >S</text></><>
      <circle
        id="T13-csn"
        stroke="black"
        cx={405}
        cy={12}
        r={8}
        {...props.settings.TS13La}
      />
      <text 
        id="T13-tsn"
        x={405}
        y={12}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS13Lat}
        >S</text>
      </><>
      <circle
        id="T13-css"
        stroke="black"
        cx={405}
        cy={78}
        r={8}
        {...props.settings.TS13Pa}
      />
      <text 
        id="T13-tss"
        x={405}
        y={78}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS13Pat}
        >S</text>
      </>
    <path
      id="T13-0"
      d={"M412.0710678118655,37.928932188134524 A10,10 0 0,0 397.9289321881345,37.928932188134524 L390.85786437626905,30.85786437626905 A20,20 0 0,1 419.14213562373095,30.85786437626905 L412.0710678118655,37.928932188134524"}
      fill="white"
      stroke="black"
      {...props.settings.T13La}
    />
    <path
      id="T13-1"
      d={"M397.9289321881345,37.928932188134524 A10,10 0 0,0 397.9289321881345,52.071067811865476 L390.85786437626905,59.14213562373095 A20,20 0 0,1 390.85786437626905,30.85786437626905 L397.9289321881345,37.928932188134524"}
      fill="white"
      stroke="black"
      {...props.settings.T13D}
    />
    <path
      id="T13-2"
      d={"M397.9289321881345,52.071067811865476 A10,10 0 0,0 412.0710678118655,52.071067811865476 L419.14213562373095,59.14213562373095 A20,20 0 0,1 390.85786437626905,59.14213562373095 L397.9289321881345,52.071067811865476"}
      fill="white"
      stroke="black"
      {...props.settings.T13Pa}
    />
    <path
      id="T13-3"
      d={"M412.0710678118655,52.071067811865476 A10,10 0 0,0 412.0710678118655,37.928932188134524 L419.14213562373095,30.857864376269053 A20,20 0 0,1 419.14213562373095,59.14213562373095 L412.0710678118655,52.071067811865476"}
      fill="white"
      stroke="black"
      {...props.settings.T13M}
    />
    {props.settings.T13?.implant && 
      <g>
      <image href="/static/images/implantTooth.png" x={373} y={13} height="65" width="65"/>
    </g>}

    <circle
      id="T14-5"
      fill="white"
      stroke="black"
      cx={340} 
      cy={45}
      r={23}
      {...props.settings.T14C}
    />
    <circle
      id="T14-4"
      fill="white"
      stroke="black"
      cx={340} 
      cy={45}
      r={10}
      {...props.settings.T14O}
    />
       <>
      <rect id="T14-rs"
      x={299}
      y={33}
      width={16} 
      height={24}
      {...props.settings.TS14S15}  
      fill="white"
      stroke="none"
      /> 
      <circle
      id="T14-cs"
      stroke="black"
      cx={307}
      cy={45}
      r={8}
      {...props.settings.TS14S15}
      />
      <text 
        id="T14-ts"
        x={307}
        y={45}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS14S15t}
        >S</text></><>
      <circle
        id="T14-csn"
        stroke="black"
        cx={340}
        cy={12}
        r={8}
        {...props.settings.TS14B}
      />
      <text 
        id="T14-tsn"
        x={340}
        y={12}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS14Bt}
        >S</text>
      </><>
      <circle
        id="T14-css"
        stroke="black"
        cx={340}
        cy={78}
        r={8}
        {...props.settings.TS14Pa}
      />
      <text 
        id="T14-tss"
        x={340}
        y={78}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS14Pat}
        >S</text>
      </>
    <path
      id="T14-0"
      d={"M347.0710678118655,37.928932188134524 A10,10 0 0,0 332.9289321881345,37.928932188134524 L325.85786437626905,30.85786437626905 A20,20 0 0,1 354.14213562373095,30.85786437626905 L347.0710678118655,37.928932188134524"}
      fill="white"
      stroke="black"
      {...props.settings.T14B}
    />
    <path
      id="T14-1"
      d={"M332.9289321881345,37.928932188134524 A10,10 0 0,0 332.9289321881345,52.071067811865476 L325.85786437626905,59.14213562373095 A20,20 0 0,1 325.85786437626905,30.85786437626905 L332.9289321881345,37.928932188134524"}
      fill="white"
      stroke="black"
      {...props.settings.T14D}
    />
    <path
      id="T14-2"
      d={"M332.9289321881345,52.071067811865476 A10,10 0 0,0 347.0710678118655,52.071067811865476 L354.14213562373095,59.14213562373095 A20,20 0 0,1 325.85786437626905,59.14213562373095 L332.9289321881345,52.071067811865476"}
      fill="white"
      stroke="black"
      {...props.settings.T14Pa}
    />
    <path
      id="T14-3"
      d={"M347.0710678118655,52.071067811865476 A10,10 0 0,0 347.0710678118655,37.928932188134524 L354.14213562373095,30.857864376269053 A20,20 0 0,1 354.14213562373095,59.14213562373095 L347.0710678118655,52.071067811865476"}
      fill="white"
      stroke="black"
      {...props.settings.T14M}
    />
    {props.settings.T14?.implant && 
      <g>
      <image href="/static/images/implantTooth.png" x={308} y={13} height="65" width="65"/>
    </g>}

    <circle
      id="T15-5"
      fill="white"
      stroke="black"
      cx={275} 
      cy={45}
      r={23}
      {...props.settings.T15C}
    />
    <circle
      id="T15-4"
      fill="white"
      stroke="black"
      cx={275} 
      cy={45}
      r={10}
      {...props.settings.T15O}
    />
       <>
      <rect id="T15-rs"
      x={234}
      y={33}
      width={16} 
      height={24}
      {...props.settings.TS15S16}  
      fill="white"
      stroke="none"
      /> 
      <circle
      id="T15-cs"
      stroke="black"
      cx={242}
      cy={45}
      r={8}
      {...props.settings.TS15S16}
      />
      <text 
        id="T15-ts"
        x={242}
        y={45}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS15S16t}
        >S</text></><>
      <circle
        id="T15-csn"
        stroke="black"
        cx={275}
        cy={12}
        r={8}
        {...props.settings.TS15B}
      />
      <text 
        id="T15-tsn"
        x={275}
        y={12}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS15Bt}
        >S</text>
      </><>
      <circle
        id="T15-css"
        stroke="black"
        cx={275}
        cy={78}
        r={8}
        {...props.settings.TS15Pa}
      />
      <text 
        id="T15-tss"
        x={275}
        y={78}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS15Pat}
        >S</text>
      </>
    <path
      id="T15-0"
      d={"M282.0710678118655,37.928932188134524 A10,10 0 0,0 267.9289321881345,37.928932188134524 L260.85786437626905,30.85786437626905 A20,20 0 0,1 289.14213562373095,30.85786437626905 L282.0710678118655,37.928932188134524"}
      fill="white"
      stroke="black"
      {...props.settings.T15B}
    />
    <path
      id="T15-1"
      d={"M267.9289321881345,37.928932188134524 A10,10 0 0,0 267.9289321881345,52.071067811865476 L260.85786437626905,59.14213562373095 A20,20 0 0,1 260.85786437626905,30.85786437626905 L267.9289321881345,37.928932188134524"}
      fill="white"
      stroke="black"
      {...props.settings.T15D}
    />
    <path
      id="T15-2"
      d={"M267.9289321881345,52.071067811865476 A10,10 0 0,0 282.0710678118655,52.071067811865476 L289.14213562373095,59.14213562373095 A20,20 0 0,1 260.85786437626905,59.14213562373095 L267.9289321881345,52.071067811865476"}
      fill="white"
      stroke="black"
      {...props.settings.T15Pa}
    />
    <path
      id="T15-3"
      d={"M282.0710678118655,52.071067811865476 A10,10 0 0,0 282.0710678118655,37.928932188134524 L289.14213562373095,30.857864376269053 A20,20 0 0,1 289.14213562373095,59.14213562373095 L282.0710678118655,52.071067811865476"}
      fill="white"
      stroke="black"
      {...props.settings.T15M}
    />
    {props.settings.T15?.implant && 
      <g>
      <image href="/static/images/implantTooth.png" x={243} y={13} height="65" width="65"/>
    </g>}

    <circle
      id="T16-5"
      fill="white"
      stroke="black"
      cx={210} 
      cy={45}
      r={23}
      {...props.settings.T16C}
    />
    <circle
      id="T16-4"
      fill="white"
      stroke="black"
      cx={210} 
      cy={45}
      r={10}
      {...props.settings.T16O}
    />
       <>
      <rect id="T16-rs"
      x={169}
      y={33}
      width={16} 
      height={24}
      {...props.settings.TS16S17}  
      fill="white"
      stroke="none"
      /> 
      <circle
      id="T16-cs"
      stroke="black"
      cx={177}
      cy={45}
      r={8}
      {...props.settings.TS16S17}
      />
      <text 
        id="T16-ts"
        x={177}
        y={45}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS16S17t}
        >S</text></><>
      <circle
        id="T16-csn"
        stroke="black"
        cx={210}
        cy={12}
        r={8}
        {...props.settings.TS16B}
      />
      <text 
        id="T16-tsn"
        x={210}
        y={12}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS16Bt}
        >S</text>
      </><>
      <circle
        id="T16-css"
        stroke="black"
        cx={210}
        cy={78}
        r={8}
        {...props.settings.TS16Pa}
      />
      <text 
        id="T16-tss"
        x={210}
        y={78}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS16Pat}
        >S</text>
      </>
    <path
      id="T16-0"
      d={"M217.07106781186548,37.928932188134524 A10,10 0 0,0 202.92893218813452,37.928932188134524 L195.85786437626905,30.85786437626905 A20,20 0 0,1 224.14213562373095,30.85786437626905 L217.07106781186548,37.928932188134524"}
      fill="white"
      stroke="black"
      {...props.settings.T16B}
    />
    <path
      id="T16-1"
      d={"M202.92893218813452,37.928932188134524 A10,10 0 0,0 202.92893218813452,52.071067811865476 L195.85786437626905,59.14213562373095 A20,20 0 0,1 195.85786437626905,30.85786437626905 L202.92893218813452,37.928932188134524"}
      fill="white"
      stroke="black"
      {...props.settings.T16D}
    />
    <path
      id="T16-2"
      d={"M202.92893218813452,52.071067811865476 A10,10 0 0,0 217.07106781186548,52.071067811865476 L224.14213562373095,59.14213562373095 A20,20 0 0,1 195.85786437626905,59.14213562373095 L202.92893218813452,52.071067811865476"}
      fill="white"
      stroke="black"
      {...props.settings.T16Pa}
    />
    <path
      id="T16-3"
      d={"M217.07106781186548,52.071067811865476 A10,10 0 0,0 217.07106781186548,37.928932188134524 L224.14213562373095,30.857864376269053 A20,20 0 0,1 224.14213562373095,59.14213562373095 L217.07106781186548,52.071067811865476"}
      fill="white"
      stroke="black"
      {...props.settings.T16M}
    />
    {props.settings.T16?.implant && 
      <g>
      <image href="/static/images/implantTooth.png" x={178} y={13} height="65" width="65"/>
    </g>}

    <circle
      id="T17-5"
      fill="white"
      stroke="black"
      cx={145} 
      cy={45}
      r={23}
      {...props.settings.T17C}
    />
    <circle
      id="T17-4"
      fill="white"
      stroke="black"
      cx={145} 
      cy={45}
      r={10}
      {...props.settings.T17O}
    />
       <>
      <rect id="T17-rs"
      x={104}
      y={33}
      width={16} 
      height={24}
      {...props.settings.TS17S18}  
      fill="white"
      stroke="none"
      /> 
      <circle
      id="T17-cs"
      stroke="black"
      cx={112}
      cy={45}
      r={8}
      {...props.settings.TS17S18}
      />
      <text 
        id="T17-ts"
        x={112}
        y={45}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS17S18t}
        >S</text></><>
      <circle
        id="T17-csn"
        stroke="black"
        cx={145}
        cy={12}
        r={8}
        {...props.settings.TS17B}
      />
      <text 
        id="T17-tsn"
        x={145}
        y={12}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS17Bt}
        >S</text>
      </><>
      <circle
        id="T17-css"
        stroke="black"
        cx={145}
        cy={78}
        r={8}
        {...props.settings.TS17Pa}
      />
      <text 
        id="T17-tss"
        x={145}
        y={78}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS17Pat}
        >S</text>
      </>
    <path
      id="T17-0"
      d={"M152.07106781186548,37.928932188134524 A10,10 0 0,0 137.92893218813452,37.928932188134524 L130.85786437626905,30.85786437626905 A20,20 0 0,1 159.14213562373095,30.85786437626905 L152.07106781186548,37.928932188134524"}
      fill="white"
      stroke="black"
      {...props.settings.T17B}
    />
    <path
      id="T17-1"
      d={"M137.92893218813452,37.928932188134524 A10,10 0 0,0 137.92893218813452,52.071067811865476 L130.85786437626905,59.14213562373095 A20,20 0 0,1 130.85786437626905,30.85786437626905 L137.92893218813452,37.928932188134524"}
      fill="white"
      stroke="black"
      {...props.settings.T17D}
    />
    <path
      id="T17-2"
      d={"M137.92893218813452,52.071067811865476 A10,10 0 0,0 152.07106781186548,52.071067811865476 L159.14213562373095,59.14213562373095 A20,20 0 0,1 130.85786437626905,59.14213562373095 L137.92893218813452,52.071067811865476"}
      fill="white"
      stroke="black"
      {...props.settings.T17Pa}
    />
    <path
      id="T17-3"
      d={"M152.07106781186548,52.071067811865476 A10,10 0 0,0 152.07106781186548,37.928932188134524 L159.14213562373095,30.857864376269053 A20,20 0 0,1 159.14213562373095,59.14213562373095 L152.07106781186548,52.071067811865476"}
      fill="white"
      stroke="black"
      {...props.settings.T17M}
    />
    {props.settings.T17?.implant && 
      <g>
      <image href="/static/images/implantTooth.png" x={113} y={13} height="65" width="65"/>
    </g>}

    <circle
      id="T18-5"
      fill="white"
      stroke="black"
      cx={80} 
      cy={45}
      r={23}
      {...props.settings.T18C}
    />
    <circle
      id="T18-4"
      fill="white"
      stroke="black"
      cx={80} 
      cy={45}
      r={10}
      {...props.settings.T18O}
    />
       <>
      <rect id="T18-rs"
      x={39}
      y={33}
      width={16} 
      height={24}
      {...props.settings.TS18D}  
      fill="white"
      stroke="none"
      /> 
      <circle
      id="T18-cs"
      stroke="black"
      cx={47}
      cy={45}
      r={8}
      {...props.settings.TS18D}
      />
      <text 
        id="T18-ts"
        x={47}
        y={45}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS18Dt}
        >S</text></><>
      <circle
        id="T18-csn"
        stroke="black"
        cx={80}
        cy={12}
        r={8}
        {...props.settings.TS18B}
      />
      <text 
        id="T18-tsn"
        x={80}
        y={12}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS18Bt}
        >S</text>
      </><>
      <circle
        id="T18-css"
        stroke="black"
        cx={80}
        cy={78}
        r={8}
        {...props.settings.TS18Pa}
      />
      <text 
        id="T18-tss"
        x={80}
        y={78}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS18Pat}
        >S</text>
      </>
    <path
      id="T18-0"
      d={"M87.07106781186548,37.928932188134524 A10,10 0 0,0 72.92893218813452,37.928932188134524 L65.85786437626905,30.85786437626905 A20,20 0 0,1 94.14213562373095,30.85786437626905 L87.07106781186548,37.928932188134524"}
      fill="white"
      stroke="black"
      {...props.settings.T18B}
    />
    <path
      id="T18-1"
      d={"M72.92893218813452,37.928932188134524 A10,10 0 0,0 72.92893218813452,52.071067811865476 L65.85786437626905,59.14213562373095 A20,20 0 0,1 65.85786437626905,30.85786437626905 L72.92893218813452,37.928932188134524"}
      fill="white"
      stroke="black"
      {...props.settings.T18D}
    />
    <path
      id="T18-2"
      d={"M72.92893218813452,52.071067811865476 A10,10 0 0,0 87.07106781186548,52.071067811865476 L94.14213562373095,59.14213562373095 A20,20 0 0,1 65.85786437626905,59.14213562373095 L72.92893218813452,52.071067811865476"}
      fill="white"
      stroke="black"
      {...props.settings.T18Pa}
    />
    <path
      id="T18-3"
      d={"M87.07106781186548,52.071067811865476 A10,10 0 0,0 87.07106781186548,37.928932188134524 L94.14213562373095,30.857864376269053 A20,20 0 0,1 94.14213562373095,59.14213562373095 L87.07106781186548,52.071067811865476"}
      fill="white"
      stroke="black"
      {...props.settings.T18M}
    />
    {props.settings.T18?.implant && 
      <g>
      <image href="/static/images/implantTooth.png" x={48} y={13} height="65" width="65"/>
    </g>}

    <circle
      id="T21-5"
      fill="white"
      stroke="black"
      cx={665} 
      cy={45}
      r={23}
      {...props.settings.T21C}
    />
    <circle
      id="T21-4"
      fill="white"
      stroke="black"
      cx={665} 
      cy={45}
      r={10}
      {...props.settings.T21I}
    />
       <>
      <rect id="T21-rs"
      x={593}
      y={33}
      width={16} 
      height={24}
      {...props.settings.TS11S21}  
      fill="white"
      stroke="none"
      /> 
      <circle
      id="T21-cs"
      stroke="black"
      cx={601}
      cy={45}
      r={8}
      {...props.settings.TS11S21}
      />
      <text 
        id="T21-ts"
        x={601}
        y={45}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS11S21t}
        >S</text></><>
      <circle
        id="T21-csn"
        stroke="black"
        cx={665}
        cy={12}
        r={8}
        {...props.settings.TS21La}
      />
      <text 
        id="T21-tsn"
        x={665}
        y={12}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS21Lat}
        >S</text>
      </><>
      <circle
        id="T21-css"
        stroke="black"
        cx={665}
        cy={78}
        r={8}
        {...props.settings.TS21Pa}
      />
      <text 
        id="T21-tss"
        x={665}
        y={78}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS21Pat}
        >S</text>
      </>
    <path
      id="T21-0"
      d={"M672.0710678118655,37.928932188134524 A10,10 0 0,0 657.9289321881346,37.928932188134524 L650.857864376269,30.85786437626905 A20,20 0 0,1 679.142135623731,30.85786437626905 L672.0710678118655,37.928932188134524"}
      fill="white"
      stroke="black"
      {...props.settings.T21La}
    />
    <path
      id="T21-1"
      d={"M657.9289321881346,37.928932188134524 A10,10 0 0,0 657.9289321881345,52.071067811865476 L650.857864376269,59.14213562373095 A20,20 0 0,1 650.857864376269,30.85786437626905 L657.9289321881346,37.928932188134524"}
      fill="white"
      stroke="black"
      {...props.settings.T21M}
    />
    <path
      id="T21-2"
      d={"M657.9289321881345,52.071067811865476 A10,10 0 0,0 672.0710678118654,52.071067811865476 L679.142135623731,59.14213562373095 A20,20 0 0,1 650.857864376269,59.14213562373095 L657.9289321881345,52.071067811865476"}
      fill="white"
      stroke="black"
      {...props.settings.T21Pa}
    />
    <path
      id="T21-3"
      d={"M672.0710678118654,52.071067811865476 A10,10 0 0,0 672.0710678118655,37.928932188134524 L679.142135623731,30.857864376269053 A20,20 0 0,1 679.142135623731,59.14213562373095 L672.0710678118654,52.071067811865476"}
      fill="white"
      stroke="black"
      {...props.settings.T21D}
    />
    {props.settings.T21?.implant && 
      <g>
      <image href="/static/images/implantTooth.png" x={633} y={13} height="65" width="65"/>
    </g>}

    <circle
      id="T22-5"
      fill="white"
      stroke="black"
      cx={730} 
      cy={45}
      r={23}
      {...props.settings.T22C}
    />
    <circle
      id="T22-4"
      fill="white"
      stroke="black"
      cx={730} 
      cy={45}
      r={10}
      {...props.settings.T22I}
    />
       <>
      <rect id="T22-rs"
      x={689}
      y={33}
      width={16} 
      height={24}
      {...props.settings.TS21S22}  
      fill="white"
      stroke="none"
      /> 
      <circle
      id="T22-cs"
      stroke="black"
      cx={697}
      cy={45}
      r={8}
      {...props.settings.TS21S22}
      />
      <text 
        id="T22-ts"
        x={697}
        y={45}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS21S22t}
        >S</text></><>
      <circle
        id="T22-csn"
        stroke="black"
        cx={730}
        cy={12}
        r={8}
        {...props.settings.TS22La}
      />
      <text 
        id="T22-tsn"
        x={730}
        y={12}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS22Lat}
        >S</text>
      </><>
      <circle
        id="T22-css"
        stroke="black"
        cx={730}
        cy={78}
        r={8}
        {...props.settings.TS22Pa}
      />
      <text 
        id="T22-tss"
        x={730}
        y={78}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS22Pat}
        >S</text>
      </>
    <path
      id="T22-0"
      d={"M737.0710678118655,37.928932188134524 A10,10 0 0,0 722.9289321881346,37.928932188134524 L715.857864376269,30.85786437626905 A20,20 0 0,1 744.142135623731,30.85786437626905 L737.0710678118655,37.928932188134524"}
      fill="white"
      stroke="black"
      {...props.settings.T22La}
    />
    <path
      id="T22-1"
      d={"M722.9289321881346,37.928932188134524 A10,10 0 0,0 722.9289321881345,52.071067811865476 L715.857864376269,59.14213562373095 A20,20 0 0,1 715.857864376269,30.85786437626905 L722.9289321881346,37.928932188134524"}
      fill="white"
      stroke="black"
      {...props.settings.T22M}
    />
    <path
      id="T22-2"
      d={"M722.9289321881345,52.071067811865476 A10,10 0 0,0 737.0710678118654,52.071067811865476 L744.142135623731,59.14213562373095 A20,20 0 0,1 715.857864376269,59.14213562373095 L722.9289321881345,52.071067811865476"}
      fill="white"
      stroke="black"
      {...props.settings.T22Pa}
    />
    <path
      id="T22-3"
      d={"M737.0710678118654,52.071067811865476 A10,10 0 0,0 737.0710678118655,37.928932188134524 L744.142135623731,30.857864376269053 A20,20 0 0,1 744.142135623731,59.14213562373095 L737.0710678118654,52.071067811865476"}
      fill="white"
      stroke="black"
      {...props.settings.T22D}
    />
    {props.settings.T22?.implant && 
      <g>
      <image href="/static/images/implantTooth.png" x={698} y={13} height="65" width="65"/>
    </g>}

    <circle
      id="T23-5"
      fill="white"
      stroke="black"
      cx={795} 
      cy={45}
      r={23}
      {...props.settings.T23C}
    />
    <circle
      id="T23-4"
      fill="white"
      stroke="black"
      cx={795} 
      cy={45}
      r={10}
      {...props.settings.T23I}
    />
       <>
      <rect id="T23-rs"
      x={754}
      y={33}
      width={16} 
      height={24}
      {...props.settings.TS22S23}  
      fill="white"
      stroke="none"
      /> 
      <circle
      id="T23-cs"
      stroke="black"
      cx={762}
      cy={45}
      r={8}
      {...props.settings.TS22S23}
      />
      <text 
        id="T23-ts"
        x={762}
        y={45}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS22S23t}
        >S</text></><>
      <circle
        id="T23-csn"
        stroke="black"
        cx={795}
        cy={12}
        r={8}
        {...props.settings.TS23La}
      />
      <text 
        id="T23-tsn"
        x={795}
        y={12}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS23Lat}
        >S</text>
      </><>
      <circle
        id="T23-css"
        stroke="black"
        cx={795}
        cy={78}
        r={8}
        {...props.settings.TS23Pa}
      />
      <text 
        id="T23-tss"
        x={795}
        y={78}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS23Pat}
        >S</text>
      </>
    <path
      id="T23-0"
      d={"M802.0710678118655,37.928932188134524 A10,10 0 0,0 787.9289321881346,37.928932188134524 L780.857864376269,30.85786437626905 A20,20 0 0,1 809.142135623731,30.85786437626905 L802.0710678118655,37.928932188134524"}
      fill="white"
      stroke="black"
      {...props.settings.T23La}
    />
    <path
      id="T23-1"
      d={"M787.9289321881346,37.928932188134524 A10,10 0 0,0 787.9289321881345,52.071067811865476 L780.857864376269,59.14213562373095 A20,20 0 0,1 780.857864376269,30.85786437626905 L787.9289321881346,37.928932188134524"}
      fill="white"
      stroke="black"
      {...props.settings.T23M}
    />
    <path
      id="T23-2"
      d={"M787.9289321881345,52.071067811865476 A10,10 0 0,0 802.0710678118654,52.071067811865476 L809.142135623731,59.14213562373095 A20,20 0 0,1 780.857864376269,59.14213562373095 L787.9289321881345,52.071067811865476"}
      fill="white"
      stroke="black"
      {...props.settings.T23Pa}
    />
    <path
      id="T23-3"
      d={"M802.0710678118654,52.071067811865476 A10,10 0 0,0 802.0710678118655,37.928932188134524 L809.142135623731,30.857864376269053 A20,20 0 0,1 809.142135623731,59.14213562373095 L802.0710678118654,52.071067811865476"}
      fill="white"
      stroke="black"
      {...props.settings.T23D}
    />
    {props.settings.T23?.implant && 
      <g>
      <image href="/static/images/implantTooth.png" x={763} y={13} height="65" width="65"/>
    </g>}

    <circle
      id="T24-5"
      fill="white"
      stroke="black"
      cx={860} 
      cy={45}
      r={23}
      {...props.settings.T24C}
    />
    <circle
      id="T24-4"
      fill="white"
      stroke="black"
      cx={860} 
      cy={45}
      r={10}
      {...props.settings.T24O}
    />
       <>
      <rect id="T24-rs"
      x={819}
      y={33}
      width={16} 
      height={24}
      {...props.settings.TS23S24}  
      fill="white"
      stroke="none"
      /> 
      <circle
      id="T24-cs"
      stroke="black"
      cx={827}
      cy={45}
      r={8}
      {...props.settings.TS23S24}
      />
      <text 
        id="T24-ts"
        x={827}
        y={45}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS23S24t}
        >S</text></><>
      <circle
        id="T24-csn"
        stroke="black"
        cx={860}
        cy={12}
        r={8}
        {...props.settings.TS24B}
      />
      <text 
        id="T24-tsn"
        x={860}
        y={12}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS24Bt}
        >S</text>
      </><>
      <circle
        id="T24-css"
        stroke="black"
        cx={860}
        cy={78}
        r={8}
        {...props.settings.TS24Pa}
      />
      <text 
        id="T24-tss"
        x={860}
        y={78}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS24Pat}
        >S</text>
      </>
    <path
      id="T24-0"
      d={"M867.0710678118655,37.928932188134524 A10,10 0 0,0 852.9289321881346,37.928932188134524 L845.857864376269,30.85786437626905 A20,20 0 0,1 874.142135623731,30.85786437626905 L867.0710678118655,37.928932188134524"}
      fill="white"
      stroke="black"
      {...props.settings.T24B}
    />
    <path
      id="T24-1"
      d={"M852.9289321881346,37.928932188134524 A10,10 0 0,0 852.9289321881345,52.071067811865476 L845.857864376269,59.14213562373095 A20,20 0 0,1 845.857864376269,30.85786437626905 L852.9289321881346,37.928932188134524"}
      fill="white"
      stroke="black"
      {...props.settings.T24M}
    />
    <path
      id="T24-2"
      d={"M852.9289321881345,52.071067811865476 A10,10 0 0,0 867.0710678118654,52.071067811865476 L874.142135623731,59.14213562373095 A20,20 0 0,1 845.857864376269,59.14213562373095 L852.9289321881345,52.071067811865476"}
      fill="white"
      stroke="black"
      {...props.settings.T24Pa}
    />
    <path
      id="T24-3"
      d={"M867.0710678118654,52.071067811865476 A10,10 0 0,0 867.0710678118655,37.928932188134524 L874.142135623731,30.857864376269053 A20,20 0 0,1 874.142135623731,59.14213562373095 L867.0710678118654,52.071067811865476"}
      fill="white"
      stroke="black"
      {...props.settings.T24D}
    />
    {props.settings.T24?.implant && 
      <g>
      <image href="/static/images/implantTooth.png" x={828} y={13} height="65" width="65"/>
    </g>}

    <circle
      id="T25-5"
      fill="white"
      stroke="black"
      cx={925} 
      cy={45}
      r={23}
      {...props.settings.T25C}
    />
    <circle
      id="T25-4"
      fill="white"
      stroke="black"
      cx={925} 
      cy={45}
      r={10}
      {...props.settings.T25O}
    />
       <>
      <rect id="T25-rs"
      x={884}
      y={33}
      width={16} 
      height={24}
      {...props.settings.TS24S25}  
      fill="white"
      stroke="none"
      /> 
      <circle
      id="T25-cs"
      stroke="black"
      cx={892}
      cy={45}
      r={8}
      {...props.settings.TS24S25}
      />
      <text 
        id="T25-ts"
        x={892}
        y={45}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS24S25t}
        >S</text></><>
      <circle
        id="T25-csn"
        stroke="black"
        cx={925}
        cy={12}
        r={8}
        {...props.settings.TS25B}
      />
      <text 
        id="T25-tsn"
        x={925}
        y={12}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS25Bt}
        >S</text>
      </><>
      <circle
        id="T25-css"
        stroke="black"
        cx={925}
        cy={78}
        r={8}
        {...props.settings.TS25Pa}
      />
      <text 
        id="T25-tss"
        x={925}
        y={78}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS25Pat}
        >S</text>
      </>
    <path
      id="T25-0"
      d={"M932.0710678118655,37.928932188134524 A10,10 0 0,0 917.9289321881346,37.928932188134524 L910.857864376269,30.85786437626905 A20,20 0 0,1 939.142135623731,30.85786437626905 L932.0710678118655,37.928932188134524"}
      fill="white"
      stroke="black"
      {...props.settings.T25B}
    />
    <path
      id="T25-1"
      d={"M917.9289321881346,37.928932188134524 A10,10 0 0,0 917.9289321881345,52.071067811865476 L910.857864376269,59.14213562373095 A20,20 0 0,1 910.857864376269,30.85786437626905 L917.9289321881346,37.928932188134524"}
      fill="white"
      stroke="black"
      {...props.settings.T25M}
    />
    <path
      id="T25-2"
      d={"M917.9289321881345,52.071067811865476 A10,10 0 0,0 932.0710678118654,52.071067811865476 L939.142135623731,59.14213562373095 A20,20 0 0,1 910.857864376269,59.14213562373095 L917.9289321881345,52.071067811865476"}
      fill="white"
      stroke="black"
      {...props.settings.T25Pa}
    />
    <path
      id="T25-3"
      d={"M932.0710678118654,52.071067811865476 A10,10 0 0,0 932.0710678118655,37.928932188134524 L939.142135623731,30.857864376269053 A20,20 0 0,1 939.142135623731,59.14213562373095 L932.0710678118654,52.071067811865476"}
      fill="white"
      stroke="black"
      {...props.settings.T25D}
    />
    {props.settings.T25?.implant && 
      <g>
      <image href="/static/images/implantTooth.png" x={893} y={13} height="65" width="65"/>
    </g>}

    <circle
      id="T26-5"
      fill="white"
      stroke="black"
      cx={990} 
      cy={45}
      r={23}
      {...props.settings.T26C}
    />
    <circle
      id="T26-4"
      fill="white"
      stroke="black"
      cx={990} 
      cy={45}
      r={10}
      {...props.settings.T26O}
    />
       <>
      <rect id="T26-rs"
      x={949}
      y={33}
      width={16} 
      height={24}
      {...props.settings.TS25S26}  
      fill="white"
      stroke="none"
      /> 
      <circle
      id="T26-cs"
      stroke="black"
      cx={957}
      cy={45}
      r={8}
      {...props.settings.TS25S26}
      />
      <text 
        id="T26-ts"
        x={957}
        y={45}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS25S26t}
        >S</text></><>
      <circle
        id="T26-csn"
        stroke="black"
        cx={990}
        cy={12}
        r={8}
        {...props.settings.TS26B}
      />
      <text 
        id="T26-tsn"
        x={990}
        y={12}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS26Bt}
        >S</text>
      </><>
      <circle
        id="T26-css"
        stroke="black"
        cx={990}
        cy={78}
        r={8}
        {...props.settings.TS26Pa}
      />
      <text 
        id="T26-tss"
        x={990}
        y={78}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS26Pat}
        >S</text>
      </>
    <path
      id="T26-0"
      d={"M997.0710678118655,37.928932188134524 A10,10 0 0,0 982.9289321881346,37.928932188134524 L975.857864376269,30.85786437626905 A20,20 0 0,1 1004.142135623731,30.85786437626905 L997.0710678118655,37.928932188134524"}
      fill="white"
      stroke="black"
      {...props.settings.T26B}
    />
    <path
      id="T26-1"
      d={"M982.9289321881346,37.928932188134524 A10,10 0 0,0 982.9289321881345,52.071067811865476 L975.857864376269,59.14213562373095 A20,20 0 0,1 975.857864376269,30.85786437626905 L982.9289321881346,37.928932188134524"}
      fill="white"
      stroke="black"
      {...props.settings.T26M}
    />
    <path
      id="T26-2"
      d={"M982.9289321881345,52.071067811865476 A10,10 0 0,0 997.0710678118654,52.071067811865476 L1004.142135623731,59.14213562373095 A20,20 0 0,1 975.857864376269,59.14213562373095 L982.9289321881345,52.071067811865476"}
      fill="white"
      stroke="black"
      {...props.settings.T26Pa}
    />
    <path
      id="T26-3"
      d={"M997.0710678118654,52.071067811865476 A10,10 0 0,0 997.0710678118655,37.928932188134524 L1004.142135623731,30.857864376269053 A20,20 0 0,1 1004.142135623731,59.14213562373095 L997.0710678118654,52.071067811865476"}
      fill="white"
      stroke="black"
      {...props.settings.T26D}
    />
    {props.settings.T26?.implant && 
      <g>
      <image href="/static/images/implantTooth.png" x={958} y={13} height="65" width="65"/>
    </g>}

    <circle
      id="T27-5"
      fill="white"
      stroke="black"
      cx={1055} 
      cy={45}
      r={23}
      {...props.settings.T27C}
    />
    <circle
      id="T27-4"
      fill="white"
      stroke="black"
      cx={1055} 
      cy={45}
      r={10}
      {...props.settings.T27O}
    />
       <>
      <rect id="T27-rs"
      x={1014}
      y={33}
      width={16} 
      height={24}
      {...props.settings.TS26S27}  
      fill="white"
      stroke="none"
      /> 
      <circle
      id="T27-cs"
      stroke="black"
      cx={1022}
      cy={45}
      r={8}
      {...props.settings.TS26S27}
      />
      <text 
        id="T27-ts"
        x={1022}
        y={45}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS26S27t}
        >S</text></><>
      <circle
        id="T27-csn"
        stroke="black"
        cx={1055}
        cy={12}
        r={8}
        {...props.settings.TS27B}
      />
      <text 
        id="T27-tsn"
        x={1055}
        y={12}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS27Bt}
        >S</text>
      </><>
      <circle
        id="T27-css"
        stroke="black"
        cx={1055}
        cy={78}
        r={8}
        {...props.settings.TS27Pa}
      />
      <text 
        id="T27-tss"
        x={1055}
        y={78}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS27Pat}
        >S</text>
      </>
    <path
      id="T27-0"
      d={"M1062.0710678118655,37.928932188134524 A10,10 0 0,0 1047.9289321881345,37.928932188134524 L1040.8578643762692,30.85786437626905 A20,20 0 0,1 1069.142135623731,30.85786437626905 L1062.0710678118655,37.928932188134524"}
      fill="white"
      stroke="black"
      {...props.settings.T27B}
    />
    <path
      id="T27-1"
      d={"M1047.9289321881345,37.928932188134524 A10,10 0 0,0 1047.9289321881345,52.071067811865476 L1040.857864376269,59.14213562373095 A20,20 0 0,1 1040.8578643762692,30.85786437626905 L1047.9289321881345,37.928932188134524"}
      fill="white"
      stroke="black"
      {...props.settings.T27M}
    />
    <path
      id="T27-2"
      d={"M1047.9289321881345,52.071067811865476 A10,10 0 0,0 1062.0710678118655,52.071067811865476 L1069.1421356237308,59.14213562373095 A20,20 0 0,1 1040.857864376269,59.14213562373095 L1047.9289321881345,52.071067811865476"}
      fill="white"
      stroke="black"
      {...props.settings.T27Pa}
    />
    <path
      id="T27-3"
      d={"M1062.0710678118655,52.071067811865476 A10,10 0 0,0 1062.0710678118655,37.928932188134524 L1069.142135623731,30.857864376269053 A20,20 0 0,1 1069.1421356237308,59.14213562373095 L1062.0710678118655,52.071067811865476"}
      fill="white"
      stroke="black"
      {...props.settings.T27D}
    />
    {props.settings.T27?.implant && 
      <g>
      <image href="/static/images/implantTooth.png" x={1023} y={13} height="65" width="65"/>
    </g>}

    <circle
      id="T28-5"
      fill="white"
      stroke="black"
      cx={1120} 
      cy={45}
      r={23}
      {...props.settings.T28C}
    />
    <circle
      id="T28-4"
      fill="white"
      stroke="black"
      cx={1120} 
      cy={45}
      r={10}
      {...props.settings.T28O}
    />
       <>
      <rect id="T28-rs"
      x={1079}
      y={33}
      width={16} 
      height={24}
      {...props.settings.TS27S28}  
      fill="white"
      stroke="none"
      /> 
      <circle
      id="T28-cs"
      stroke="black"
      cx={1087}
      cy={45}
      r={8}
      {...props.settings.TS27S28}
      />
      <text 
        id="T28-ts"
        x={1087}
        y={45}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS27S28t}
        >S</text></><>
      <circle
        id="T28-csn"
        stroke="black"
        cx={1120}
        cy={12}
        r={8}
        {...props.settings.TS28B}
      />
      <text 
        id="T28-tsn"
        x={1120}
        y={12}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS28Bt}
        >S</text>
      </><>
      <circle
        id="T28-css"
        stroke="black"
        cx={1120}
        cy={78}
        r={8}
        {...props.settings.TS28Pa}
      />
      <text 
        id="T28-tss"
        x={1120}
        y={78}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS28Pat}
        >S</text>
      </><>
        <circle
        id="T28-csl"
        stroke="black"
        cx={1153}
        cy={45}
        r={8}
        {...props.settings.TS28D}
        />
        <text 
          id="T28-tsl"
          x={1153}
          y={45}
          textAnchor="middle" 
          stroke="#FFFFFF" 
          strokeWidth="0.1px" 
          dy=".3em"
          fill="white"
          {...props.settings.TS28Dt}
          >S</text></>
    <path
      id="T28-0"
      d={"M1127.0710678118655,37.928932188134524 A10,10 0 0,0 1112.9289321881345,37.928932188134524 L1105.8578643762692,30.85786437626905 A20,20 0 0,1 1134.142135623731,30.85786437626905 L1127.0710678118655,37.928932188134524"}
      fill="white"
      stroke="black"
      {...props.settings.T28B}
    />
    <path
      id="T28-1"
      d={"M1112.9289321881345,37.928932188134524 A10,10 0 0,0 1112.9289321881345,52.071067811865476 L1105.857864376269,59.14213562373095 A20,20 0 0,1 1105.8578643762692,30.85786437626905 L1112.9289321881345,37.928932188134524"}
      fill="white"
      stroke="black"
      {...props.settings.T28M}
    />
    <path
      id="T28-2"
      d={"M1112.9289321881345,52.071067811865476 A10,10 0 0,0 1127.0710678118655,52.071067811865476 L1134.1421356237308,59.14213562373095 A20,20 0 0,1 1105.857864376269,59.14213562373095 L1112.9289321881345,52.071067811865476"}
      fill="white"
      stroke="black"
      {...props.settings.T28Pa}
    />
    <path
      id="T28-3"
      d={"M1127.0710678118655,52.071067811865476 A10,10 0 0,0 1127.0710678118655,37.928932188134524 L1134.142135623731,30.857864376269053 A20,20 0 0,1 1134.1421356237308,59.14213562373095 L1127.0710678118655,52.071067811865476"}
      fill="white"
      stroke="black"
      {...props.settings.T28D}
    />
    {props.settings.T28?.implant && 
      <g>
      <image href="/static/images/implantTooth.png" x={1088} y={13} height="65" width="65"/>
    </g>}

    <circle
      id="T31-5"
      fill="white"
      stroke="black"
      cx={665} 
      cy={297}
      r={23}
      {...props.settings.T31C}
    />
    <circle
      id="T31-4"
      fill="white"
      stroke="black"
      cx={665} 
      cy={297}
      r={10}
      {...props.settings.T31I}
    />
       <>
      <rect id="T31-rs"
      x={593}
      y={285}
      width={16} 
      height={24}
      {...props.settings.TS31S41}  
      fill="white"
      stroke="none"
      /> 
      <circle
      id="T31-cs"
      stroke="black"
      cx={601}
      cy={297}
      r={8}
      {...props.settings.TS31S41}
      />
      <text 
        id="T31-ts"
        x={601}
        y={297}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS31S41t}
        >S</text></><>
      <circle
        id="T31-csn"
        stroke="black"
        cx={665}
        cy={264}
        r={8}
        {...props.settings.TS31Li}
      />
      <text 
        id="T31-tsn"
        x={665}
        y={264}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS31Lit}
        >S</text>
      </><>
      <circle
        id="T31-css"
        stroke="black"
        cx={665}
        cy={330}
        r={8}
        {...props.settings.TS31La}
      />
      <text 
        id="T31-tss"
        x={665}
        y={330}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS31Lat}
        >S</text>
      </>
    <path
      id="T31-0"
      d={"M672.0710678118655,289.9289321881345 A10,10 0 0,0 657.9289321881346,289.9289321881345 L650.857864376269,282.85786437626905 A20,20 0 0,1 679.142135623731,282.85786437626905 L672.0710678118655,289.9289321881345"}
      fill="white"
      stroke="black"
      {...props.settings.T31Li}
    />
    <path
      id="T31-1"
      d={"M657.9289321881346,289.9289321881345 A10,10 0 0,0 657.9289321881345,304.0710678118655 L650.857864376269,311.14213562373095 A20,20 0 0,1 650.857864376269,282.85786437626905 L657.9289321881346,289.9289321881345"}
      fill="white"
      stroke="black"
      {...props.settings.T31M}
    />
    <path
      id="T31-2"
      d={"M657.9289321881345,304.0710678118655 A10,10 0 0,0 672.0710678118654,304.0710678118655 L679.142135623731,311.14213562373095 A20,20 0 0,1 650.857864376269,311.14213562373095 L657.9289321881345,304.0710678118655"}
      fill="white"
      stroke="black"
      {...props.settings.T31La}
    />
    <path
      id="T31-3"
      d={"M672.0710678118654,304.0710678118655 A10,10 0 0,0 672.0710678118655,289.9289321881345 L679.142135623731,282.85786437626905 A20,20 0 0,1 679.142135623731,311.14213562373095 L672.0710678118654,304.0710678118655"}
      fill="white"
      stroke="black"
      {...props.settings.T31D}
    />
    {props.settings.T31?.implant && 
      <g>
      <image href="/static/images/implantTooth.png" x={633} y={265} height="65" width="65"/>
    </g>}

    <circle
      id="T32-5"
      fill="white"
      stroke="black"
      cx={730} 
      cy={297}
      r={23}
      {...props.settings.T32C}
    />
    <circle
      id="T32-4"
      fill="white"
      stroke="black"
      cx={730} 
      cy={297}
      r={10}
      {...props.settings.T32I}
    />
       <>
      <rect id="T32-rs"
      x={689}
      y={285}
      width={16} 
      height={24}
      {...props.settings.TS31S32}  
      fill="white"
      stroke="none"
      /> 
      <circle
      id="T32-cs"
      stroke="black"
      cx={697}
      cy={297}
      r={8}
      {...props.settings.TS31S32}
      />
      <text 
        id="T32-ts"
        x={697}
        y={297}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS31S32t}
        >S</text></><>
      <circle
        id="T32-csn"
        stroke="black"
        cx={730}
        cy={264}
        r={8}
        {...props.settings.TS32Li}
      />
      <text 
        id="T32-tsn"
        x={730}
        y={264}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS32Lit}
        >S</text>
      </><>
      <circle
        id="T32-css"
        stroke="black"
        cx={730}
        cy={330}
        r={8}
        {...props.settings.TS32La}
      />
      <text 
        id="T32-tss"
        x={730}
        y={330}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS32Lat}
        >S</text>
      </>
    <path
      id="T32-0"
      d={"M737.0710678118655,289.9289321881345 A10,10 0 0,0 722.9289321881346,289.9289321881345 L715.857864376269,282.85786437626905 A20,20 0 0,1 744.142135623731,282.85786437626905 L737.0710678118655,289.9289321881345"}
      fill="white"
      stroke="black"
      {...props.settings.T32Li}
    />
    <path
      id="T32-1"
      d={"M722.9289321881346,289.9289321881345 A10,10 0 0,0 722.9289321881345,304.0710678118655 L715.857864376269,311.14213562373095 A20,20 0 0,1 715.857864376269,282.85786437626905 L722.9289321881346,289.9289321881345"}
      fill="white"
      stroke="black"
      {...props.settings.T32M}
    />
    <path
      id="T32-2"
      d={"M722.9289321881345,304.0710678118655 A10,10 0 0,0 737.0710678118654,304.0710678118655 L744.142135623731,311.14213562373095 A20,20 0 0,1 715.857864376269,311.14213562373095 L722.9289321881345,304.0710678118655"}
      fill="white"
      stroke="black"
      {...props.settings.T32La}
    />
    <path
      id="T32-3"
      d={"M737.0710678118654,304.0710678118655 A10,10 0 0,0 737.0710678118655,289.9289321881345 L744.142135623731,282.85786437626905 A20,20 0 0,1 744.142135623731,311.14213562373095 L737.0710678118654,304.0710678118655"}
      fill="white"
      stroke="black"
      {...props.settings.T32D}
    />
    {props.settings.T32?.implant && 
      <g>
      <image href="/static/images/implantTooth.png" x={698} y={265} height="65" width="65"/>
    </g>}

    <circle
      id="T33-5"
      fill="white"
      stroke="black"
      cx={795} 
      cy={297}
      r={23}
      {...props.settings.T33C}
    />
    <circle
      id="T33-4"
      fill="white"
      stroke="black"
      cx={795} 
      cy={297}
      r={10}
      {...props.settings.T33I}
    />
       <>
      <rect id="T33-rs"
      x={754}
      y={285}
      width={16} 
      height={24}
      {...props.settings.TS32S33}  
      fill="white"
      stroke="none"
      /> 
      <circle
      id="T33-cs"
      stroke="black"
      cx={762}
      cy={297}
      r={8}
      {...props.settings.TS32S33}
      />
      <text 
        id="T33-ts"
        x={762}
        y={297}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS32S33t}
        >S</text></><>
      <circle
        id="T33-csn"
        stroke="black"
        cx={795}
        cy={264}
        r={8}
        {...props.settings.TS33Li}
      />
      <text 
        id="T33-tsn"
        x={795}
        y={264}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS33Lit}
        >S</text>
      </><>
      <circle
        id="T33-css"
        stroke="black"
        cx={795}
        cy={330}
        r={8}
        {...props.settings.TS33La}
      />
      <text 
        id="T33-tss"
        x={795}
        y={330}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS33Lat}
        >S</text>
      </>
    <path
      id="T33-0"
      d={"M802.0710678118655,289.9289321881345 A10,10 0 0,0 787.9289321881346,289.9289321881345 L780.857864376269,282.85786437626905 A20,20 0 0,1 809.142135623731,282.85786437626905 L802.0710678118655,289.9289321881345"}
      fill="white"
      stroke="black"
      {...props.settings.T33Li}
    />
    <path
      id="T33-1"
      d={"M787.9289321881346,289.9289321881345 A10,10 0 0,0 787.9289321881345,304.0710678118655 L780.857864376269,311.14213562373095 A20,20 0 0,1 780.857864376269,282.85786437626905 L787.9289321881346,289.9289321881345"}
      fill="white"
      stroke="black"
      {...props.settings.T33M}
    />
    <path
      id="T33-2"
      d={"M787.9289321881345,304.0710678118655 A10,10 0 0,0 802.0710678118654,304.0710678118655 L809.142135623731,311.14213562373095 A20,20 0 0,1 780.857864376269,311.14213562373095 L787.9289321881345,304.0710678118655"}
      fill="white"
      stroke="black"
      {...props.settings.T33La}
    />
    <path
      id="T33-3"
      d={"M802.0710678118654,304.0710678118655 A10,10 0 0,0 802.0710678118655,289.9289321881345 L809.142135623731,282.85786437626905 A20,20 0 0,1 809.142135623731,311.14213562373095 L802.0710678118654,304.0710678118655"}
      fill="white"
      stroke="black"
      {...props.settings.T33D}
    />
    {props.settings.T33?.implant && 
      <g>
      <image href="/static/images/implantTooth.png" x={763} y={265} height="65" width="65"/>
    </g>}

    <circle
      id="T34-5"
      fill="white"
      stroke="black"
      cx={860} 
      cy={297}
      r={23}
      {...props.settings.T34C}
    />
    <circle
      id="T34-4"
      fill="white"
      stroke="black"
      cx={860} 
      cy={297}
      r={10}
      {...props.settings.T34O}
    />
       <>
      <rect id="T34-rs"
      x={819}
      y={285}
      width={16} 
      height={24}
      {...props.settings.TS33S34}  
      fill="white"
      stroke="none"
      /> 
      <circle
      id="T34-cs"
      stroke="black"
      cx={827}
      cy={297}
      r={8}
      {...props.settings.TS33S34}
      />
      <text 
        id="T34-ts"
        x={827}
        y={297}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS33S34t}
        >S</text></><>
      <circle
        id="T34-csn"
        stroke="black"
        cx={860}
        cy={264}
        r={8}
        {...props.settings.TS34Li}
      />
      <text 
        id="T34-tsn"
        x={860}
        y={264}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS34Lit}
        >S</text>
      </><>
      <circle
        id="T34-css"
        stroke="black"
        cx={860}
        cy={330}
        r={8}
        {...props.settings.TS34B}
      />
      <text 
        id="T34-tss"
        x={860}
        y={330}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS34Bt}
        >S</text>
      </>
    <path
      id="T34-0"
      d={"M867.0710678118655,289.9289321881345 A10,10 0 0,0 852.9289321881346,289.9289321881345 L845.857864376269,282.85786437626905 A20,20 0 0,1 874.142135623731,282.85786437626905 L867.0710678118655,289.9289321881345"}
      fill="white"
      stroke="black"
      {...props.settings.T34Li}
    />
    <path
      id="T34-1"
      d={"M852.9289321881346,289.9289321881345 A10,10 0 0,0 852.9289321881345,304.0710678118655 L845.857864376269,311.14213562373095 A20,20 0 0,1 845.857864376269,282.85786437626905 L852.9289321881346,289.9289321881345"}
      fill="white"
      stroke="black"
      {...props.settings.T34M}
    />
    <path
      id="T34-2"
      d={"M852.9289321881345,304.0710678118655 A10,10 0 0,0 867.0710678118654,304.0710678118655 L874.142135623731,311.14213562373095 A20,20 0 0,1 845.857864376269,311.14213562373095 L852.9289321881345,304.0710678118655"}
      fill="white"
      stroke="black"
      {...props.settings.T34B}
    />
    <path
      id="T34-3"
      d={"M867.0710678118654,304.0710678118655 A10,10 0 0,0 867.0710678118655,289.9289321881345 L874.142135623731,282.85786437626905 A20,20 0 0,1 874.142135623731,311.14213562373095 L867.0710678118654,304.0710678118655"}
      fill="white"
      stroke="black"
      {...props.settings.T34D}
    />
    {props.settings.T34?.implant && 
      <g>
      <image href="/static/images/implantTooth.png" x={828} y={265} height="65" width="65"/>
    </g>}

    <circle
      id="T35-5"
      fill="white"
      stroke="black"
      cx={925} 
      cy={297}
      r={23}
      {...props.settings.T35C}
    />
    <circle
      id="T35-4"
      fill="white"
      stroke="black"
      cx={925} 
      cy={297}
      r={10}
      {...props.settings.T35O}
    />
       <>
      <rect id="T35-rs"
      x={884}
      y={285}
      width={16} 
      height={24}
      {...props.settings.TS34S35}  
      fill="white"
      stroke="none"
      /> 
      <circle
      id="T35-cs"
      stroke="black"
      cx={892}
      cy={297}
      r={8}
      {...props.settings.TS34S35}
      />
      <text 
        id="T35-ts"
        x={892}
        y={297}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS34S35t}
        >S</text></><>
      <circle
        id="T35-csn"
        stroke="black"
        cx={925}
        cy={264}
        r={8}
        {...props.settings.TS35Li}
      />
      <text 
        id="T35-tsn"
        x={925}
        y={264}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS35Lit}
        >S</text>
      </><>
      <circle
        id="T35-css"
        stroke="black"
        cx={925}
        cy={330}
        r={8}
        {...props.settings.TS35B}
      />
      <text 
        id="T35-tss"
        x={925}
        y={330}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS35Bt}
        >S</text>
      </>
    <path
      id="T35-0"
      d={"M932.0710678118655,289.9289321881345 A10,10 0 0,0 917.9289321881346,289.9289321881345 L910.857864376269,282.85786437626905 A20,20 0 0,1 939.142135623731,282.85786437626905 L932.0710678118655,289.9289321881345"}
      fill="white"
      stroke="black"
      {...props.settings.T35Li}
    />
    <path
      id="T35-1"
      d={"M917.9289321881346,289.9289321881345 A10,10 0 0,0 917.9289321881345,304.0710678118655 L910.857864376269,311.14213562373095 A20,20 0 0,1 910.857864376269,282.85786437626905 L917.9289321881346,289.9289321881345"}
      fill="white"
      stroke="black"
      {...props.settings.T35M}
    />
    <path
      id="T35-2"
      d={"M917.9289321881345,304.0710678118655 A10,10 0 0,0 932.0710678118654,304.0710678118655 L939.142135623731,311.14213562373095 A20,20 0 0,1 910.857864376269,311.14213562373095 L917.9289321881345,304.0710678118655"}
      fill="white"
      stroke="black"
      {...props.settings.T35B}
    />
    <path
      id="T35-3"
      d={"M932.0710678118654,304.0710678118655 A10,10 0 0,0 932.0710678118655,289.9289321881345 L939.142135623731,282.85786437626905 A20,20 0 0,1 939.142135623731,311.14213562373095 L932.0710678118654,304.0710678118655"}
      fill="white"
      stroke="black"
      {...props.settings.T35D}
    />
    {props.settings.T35?.implant && 
      <g>
      <image href="/static/images/implantTooth.png" x={893} y={265} height="65" width="65"/>
    </g>}

    <circle
      id="T36-5"
      fill="white"
      stroke="black"
      cx={990} 
      cy={297}
      r={23}
      {...props.settings.T36C}
    />
    <circle
      id="T36-4"
      fill="white"
      stroke="black"
      cx={990} 
      cy={297}
      r={10}
      {...props.settings.T36O}
    />
       <>
      <rect id="T36-rs"
      x={949}
      y={285}
      width={16} 
      height={24}
      {...props.settings.TS35S36}  
      fill="white"
      stroke="none"
      /> 
      <circle
      id="T36-cs"
      stroke="black"
      cx={957}
      cy={297}
      r={8}
      {...props.settings.TS35S36}
      />
      <text 
        id="T36-ts"
        x={957}
        y={297}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS35S36t}
        >S</text></><>
      <circle
        id="T36-csn"
        stroke="black"
        cx={990}
        cy={264}
        r={8}
        {...props.settings.TS36Li}
      />
      <text 
        id="T36-tsn"
        x={990}
        y={264}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS36Lit}
        >S</text>
      </><>
      <circle
        id="T36-css"
        stroke="black"
        cx={990}
        cy={330}
        r={8}
        {...props.settings.TS36B}
      />
      <text 
        id="T36-tss"
        x={990}
        y={330}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS36Bt}
        >S</text>
      </>
    <path
      id="T36-0"
      d={"M997.0710678118655,289.9289321881345 A10,10 0 0,0 982.9289321881346,289.9289321881345 L975.857864376269,282.85786437626905 A20,20 0 0,1 1004.142135623731,282.85786437626905 L997.0710678118655,289.9289321881345"}
      fill="white"
      stroke="black"
      {...props.settings.T36Li}
    />
    <path
      id="T36-1"
      d={"M982.9289321881346,289.9289321881345 A10,10 0 0,0 982.9289321881345,304.0710678118655 L975.857864376269,311.14213562373095 A20,20 0 0,1 975.857864376269,282.85786437626905 L982.9289321881346,289.9289321881345"}
      fill="white"
      stroke="black"
      {...props.settings.T36M}
    />
    <path
      id="T36-2"
      d={"M982.9289321881345,304.0710678118655 A10,10 0 0,0 997.0710678118654,304.0710678118655 L1004.142135623731,311.14213562373095 A20,20 0 0,1 975.857864376269,311.14213562373095 L982.9289321881345,304.0710678118655"}
      fill="white"
      stroke="black"
      {...props.settings.T36B}
    />
    <path
      id="T36-3"
      d={"M997.0710678118654,304.0710678118655 A10,10 0 0,0 997.0710678118655,289.9289321881345 L1004.142135623731,282.85786437626905 A20,20 0 0,1 1004.142135623731,311.14213562373095 L997.0710678118654,304.0710678118655"}
      fill="white"
      stroke="black"
      {...props.settings.T36D}
    />
    {props.settings.T36?.implant && 
      <g>
      <image href="/static/images/implantTooth.png" x={958} y={265} height="65" width="65"/>
    </g>}

    <circle
      id="T37-5"
      fill="white"
      stroke="black"
      cx={1055} 
      cy={297}
      r={23}
      {...props.settings.T37C}
    />
    <circle
      id="T37-4"
      fill="white"
      stroke="black"
      cx={1055} 
      cy={297}
      r={10}
      {...props.settings.T37O}
    />
       <>
      <rect id="T37-rs"
      x={1014}
      y={285}
      width={16} 
      height={24}
      {...props.settings.TS36S37}  
      fill="white"
      stroke="none"
      /> 
      <circle
      id="T37-cs"
      stroke="black"
      cx={1022}
      cy={297}
      r={8}
      {...props.settings.TS36S37}
      />
      <text 
        id="T37-ts"
        x={1022}
        y={297}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS36S37t}
        >S</text></><>
      <circle
        id="T37-csn"
        stroke="black"
        cx={1055}
        cy={264}
        r={8}
        {...props.settings.TS37Li}
      />
      <text 
        id="T37-tsn"
        x={1055}
        y={264}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS37Lit}
        >S</text>
      </><>
      <circle
        id="T37-css"
        stroke="black"
        cx={1055}
        cy={330}
        r={8}
        {...props.settings.TS37B}
      />
      <text 
        id="T37-tss"
        x={1055}
        y={330}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS37Bt}
        >S</text>
      </>
    <path
      id="T37-0"
      d={"M1062.0710678118655,289.9289321881345 A10,10 0 0,0 1047.9289321881345,289.9289321881345 L1040.8578643762692,282.85786437626905 A20,20 0 0,1 1069.142135623731,282.85786437626905 L1062.0710678118655,289.9289321881345"}
      fill="white"
      stroke="black"
      {...props.settings.T37Li}
    />
    <path
      id="T37-1"
      d={"M1047.9289321881345,289.9289321881345 A10,10 0 0,0 1047.9289321881345,304.0710678118655 L1040.857864376269,311.14213562373095 A20,20 0 0,1 1040.8578643762692,282.85786437626905 L1047.9289321881345,289.9289321881345"}
      fill="white"
      stroke="black"
      {...props.settings.T37M}
    />
    <path
      id="T37-2"
      d={"M1047.9289321881345,304.0710678118655 A10,10 0 0,0 1062.0710678118655,304.0710678118655 L1069.1421356237308,311.14213562373095 A20,20 0 0,1 1040.857864376269,311.14213562373095 L1047.9289321881345,304.0710678118655"}
      fill="white"
      stroke="black"
      {...props.settings.T37B}
    />
    <path
      id="T37-3"
      d={"M1062.0710678118655,304.0710678118655 A10,10 0 0,0 1062.0710678118655,289.9289321881345 L1069.142135623731,282.85786437626905 A20,20 0 0,1 1069.1421356237308,311.14213562373095 L1062.0710678118655,304.0710678118655"}
      fill="white"
      stroke="black"
      {...props.settings.T37D}
    />
    {props.settings.T37?.implant && 
      <g>
      <image href="/static/images/implantTooth.png" x={1023} y={265} height="65" width="65"/>
    </g>}

    <circle
      id="T38-5"
      fill="white"
      stroke="black"
      cx={1120} 
      cy={297}
      r={23}
      {...props.settings.T38C}
    />
    <circle
      id="T38-4"
      fill="white"
      stroke="black"
      cx={1120} 
      cy={297}
      r={10}
      {...props.settings.T38O}
    />
       <>
      <rect id="T38-rs"
      x={1079}
      y={285}
      width={16} 
      height={24}
      {...props.settings.TS37S38}  
      fill="white"
      stroke="none"
      /> 
      <circle
      id="T38-cs"
      stroke="black"
      cx={1087}
      cy={297}
      r={8}
      {...props.settings.TS37S38}
      />
      <text 
        id="T38-ts"
        x={1087}
        y={297}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS37S38t}
        >S</text></><>
      <circle
        id="T38-csn"
        stroke="black"
        cx={1120}
        cy={264}
        r={8}
        {...props.settings.TS38Li}
      />
      <text 
        id="T38-tsn"
        x={1120}
        y={264}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS38Lit}
        >S</text>
      </><>
      <circle
        id="T38-css"
        stroke="black"
        cx={1120}
        cy={330}
        r={8}
        {...props.settings.TS38B}
      />
      <text 
        id="T38-tss"
        x={1120}
        y={330}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS38Bt}
        >S</text>
      </><>
        <circle
        id="T38-csl"
        stroke="black"
        cx={1153}
        cy={297}
        r={8}
        {...props.settings.TS38D}
        />
        <text 
          id="T38-tsl"
          x={1153}
          y={297}
          textAnchor="middle" 
          stroke="#FFFFFF" 
          strokeWidth="0.1px" 
          dy=".3em"
          fill="white"
          {...props.settings.TS38Dt}
          >S</text></>
    <path
      id="T38-0"
      d={"M1127.0710678118655,289.9289321881345 A10,10 0 0,0 1112.9289321881345,289.9289321881345 L1105.8578643762692,282.85786437626905 A20,20 0 0,1 1134.142135623731,282.85786437626905 L1127.0710678118655,289.9289321881345"}
      fill="white"
      stroke="black"
      {...props.settings.T38Li}
    />
    <path
      id="T38-1"
      d={"M1112.9289321881345,289.9289321881345 A10,10 0 0,0 1112.9289321881345,304.0710678118655 L1105.857864376269,311.14213562373095 A20,20 0 0,1 1105.8578643762692,282.85786437626905 L1112.9289321881345,289.9289321881345"}
      fill="white"
      stroke="black"
      {...props.settings.T38M}
    />
    <path
      id="T38-2"
      d={"M1112.9289321881345,304.0710678118655 A10,10 0 0,0 1127.0710678118655,304.0710678118655 L1134.1421356237308,311.14213562373095 A20,20 0 0,1 1105.857864376269,311.14213562373095 L1112.9289321881345,304.0710678118655"}
      fill="white"
      stroke="black"
      {...props.settings.T38B}
    />
    <path
      id="T38-3"
      d={"M1127.0710678118655,304.0710678118655 A10,10 0 0,0 1127.0710678118655,289.9289321881345 L1134.142135623731,282.85786437626905 A20,20 0 0,1 1134.1421356237308,311.14213562373095 L1127.0710678118655,304.0710678118655"}
      fill="white"
      stroke="black"
      {...props.settings.T38D}
    />
    {props.settings.T38?.implant && 
      <g>
      <image href="/static/images/implantTooth.png" x={1088} y={265} height="65" width="65"/>
    </g>}

    <circle
      id="T41-5"
      fill="white"
      stroke="black"
      cx={535} 
      cy={297}
      r={23}
      {...props.settings.T41C}
    />
    <circle
      id="T41-4"
      fill="white"
      stroke="black"
      cx={535} 
      cy={297}
      r={10}
      {...props.settings.T41I}
    />
       <>
      <rect id="T41-rs"
      x={494}
      y={285}
      width={16} 
      height={24}
      {...props.settings.TS41S42}  
      fill="white"
      stroke="none"
      /> 
      <circle
      id="T41-cs"
      stroke="black"
      cx={502}
      cy={297}
      r={8}
      {...props.settings.TS41S42}
      />
      <text 
        id="T41-ts"
        x={502}
        y={297}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS41S42t}
        >S</text></><>
      <circle
        id="T41-csn"
        stroke="black"
        cx={535}
        cy={264}
        r={8}
        {...props.settings.TS41Li}
      />
      <text 
        id="T41-tsn"
        x={535}
        y={264}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS41Lit}
        >S</text>
      </><>
      <circle
        id="T41-css"
        stroke="black"
        cx={535}
        cy={330}
        r={8}
        {...props.settings.TS41La}
      />
      <text 
        id="T41-tss"
        x={535}
        y={330}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS41Lat}
        >S</text>
      </>
    <path
      id="T41-0"
      d={"M542.0710678118655,289.9289321881345 A10,10 0 0,0 527.9289321881346,289.9289321881345 L520.857864376269,282.85786437626905 A20,20 0 0,1 549.142135623731,282.85786437626905 L542.0710678118655,289.9289321881345"}
      fill="white"
      stroke="black"
      {...props.settings.T41Li}
    />
    <path
      id="T41-1"
      d={"M527.9289321881346,289.9289321881345 A10,10 0 0,0 527.9289321881345,304.0710678118655 L520.857864376269,311.14213562373095 A20,20 0 0,1 520.857864376269,282.85786437626905 L527.9289321881346,289.9289321881345"}
      fill="white"
      stroke="black"
      {...props.settings.T41D}
    />
    <path
      id="T41-2"
      d={"M527.9289321881345,304.0710678118655 A10,10 0 0,0 542.0710678118654,304.0710678118655 L549.142135623731,311.14213562373095 A20,20 0 0,1 520.857864376269,311.14213562373095 L527.9289321881345,304.0710678118655"}
      fill="white"
      stroke="black"
      {...props.settings.T41La}
    />
    <path
      id="T41-3"
      d={"M542.0710678118654,304.0710678118655 A10,10 0 0,0 542.0710678118655,289.9289321881345 L549.142135623731,282.85786437626905 A20,20 0 0,1 549.142135623731,311.14213562373095 L542.0710678118654,304.0710678118655"}
      fill="white"
      stroke="black"
      {...props.settings.T41M}
    />
    {props.settings.T41?.implant && 
      <g>
      <image href="/static/images/implantTooth.png" x={503} y={265} height="65" width="65"/>
    </g>}

    <circle
      id="T42-5"
      fill="white"
      stroke="black"
      cx={470} 
      cy={297}
      r={23}
      {...props.settings.T42C}
    />
    <circle
      id="T42-4"
      fill="white"
      stroke="black"
      cx={470} 
      cy={297}
      r={10}
      {...props.settings.T42I}
    />
       <>
      <rect id="T42-rs"
      x={429}
      y={285}
      width={16} 
      height={24}
      {...props.settings.TS42S43}  
      fill="white"
      stroke="none"
      /> 
      <circle
      id="T42-cs"
      stroke="black"
      cx={437}
      cy={297}
      r={8}
      {...props.settings.TS42S43}
      />
      <text 
        id="T42-ts"
        x={437}
        y={297}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS42S43t}
        >S</text></><>
      <circle
        id="T42-csn"
        stroke="black"
        cx={470}
        cy={264}
        r={8}
        {...props.settings.TS42Li}
      />
      <text 
        id="T42-tsn"
        x={470}
        y={264}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS42Lit}
        >S</text>
      </><>
      <circle
        id="T42-css"
        stroke="black"
        cx={470}
        cy={330}
        r={8}
        {...props.settings.TS42La}
      />
      <text 
        id="T42-tss"
        x={470}
        y={330}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS42Lat}
        >S</text>
      </>
    <path
      id="T42-0"
      d={"M477.0710678118655,289.9289321881345 A10,10 0 0,0 462.9289321881345,289.9289321881345 L455.85786437626905,282.85786437626905 A20,20 0 0,1 484.14213562373095,282.85786437626905 L477.0710678118655,289.9289321881345"}
      fill="white"
      stroke="black"
      {...props.settings.T42Li}
    />
    <path
      id="T42-1"
      d={"M462.9289321881345,289.9289321881345 A10,10 0 0,0 462.9289321881345,304.0710678118655 L455.85786437626905,311.14213562373095 A20,20 0 0,1 455.85786437626905,282.85786437626905 L462.9289321881345,289.9289321881345"}
      fill="white"
      stroke="black"
      {...props.settings.T42D}
    />
    <path
      id="T42-2"
      d={"M462.9289321881345,304.0710678118655 A10,10 0 0,0 477.0710678118655,304.0710678118655 L484.14213562373095,311.14213562373095 A20,20 0 0,1 455.85786437626905,311.14213562373095 L462.9289321881345,304.0710678118655"}
      fill="white"
      stroke="black"
      {...props.settings.T42La}
    />
    <path
      id="T42-3"
      d={"M477.0710678118655,304.0710678118655 A10,10 0 0,0 477.0710678118655,289.9289321881345 L484.14213562373095,282.85786437626905 A20,20 0 0,1 484.14213562373095,311.14213562373095 L477.0710678118655,304.0710678118655"}
      fill="white"
      stroke="black"
      {...props.settings.T42M}
    />
    {props.settings.T42?.implant && 
      <g>
      <image href="/static/images/implantTooth.png" x={438} y={265} height="65" width="65"/>
    </g>}

    <circle
      id="T43-5"
      fill="white"
      stroke="black"
      cx={405} 
      cy={297}
      r={23}
      {...props.settings.T43C}
    />
    <circle
      id="T43-4"
      fill="white"
      stroke="black"
      cx={405} 
      cy={297}
      r={10}
      {...props.settings.T43I}
    />
       <>
      <rect id="T43-rs"
      x={364}
      y={285}
      width={16} 
      height={24}
      {...props.settings.TS43S44}  
      fill="white"
      stroke="none"
      /> 
      <circle
      id="T43-cs"
      stroke="black"
      cx={372}
      cy={297}
      r={8}
      {...props.settings.TS43S44}
      />
      <text 
        id="T43-ts"
        x={372}
        y={297}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS43S44t}
        >S</text></><>
      <circle
        id="T43-csn"
        stroke="black"
        cx={405}
        cy={264}
        r={8}
        {...props.settings.TS43Li}
      />
      <text 
        id="T43-tsn"
        x={405}
        y={264}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS43Lit}
        >S</text>
      </><>
      <circle
        id="T43-css"
        stroke="black"
        cx={405}
        cy={330}
        r={8}
        {...props.settings.TS43La}
      />
      <text 
        id="T43-tss"
        x={405}
        y={330}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS43Lat}
        >S</text>
      </>
    <path
      id="T43-0"
      d={"M412.0710678118655,289.9289321881345 A10,10 0 0,0 397.9289321881345,289.9289321881345 L390.85786437626905,282.85786437626905 A20,20 0 0,1 419.14213562373095,282.85786437626905 L412.0710678118655,289.9289321881345"}
      fill="white"
      stroke="black"
      {...props.settings.T43Li}
    />
    <path
      id="T43-1"
      d={"M397.9289321881345,289.9289321881345 A10,10 0 0,0 397.9289321881345,304.0710678118655 L390.85786437626905,311.14213562373095 A20,20 0 0,1 390.85786437626905,282.85786437626905 L397.9289321881345,289.9289321881345"}
      fill="white"
      stroke="black"
      {...props.settings.T43D}
    />
    <path
      id="T43-2"
      d={"M397.9289321881345,304.0710678118655 A10,10 0 0,0 412.0710678118655,304.0710678118655 L419.14213562373095,311.14213562373095 A20,20 0 0,1 390.85786437626905,311.14213562373095 L397.9289321881345,304.0710678118655"}
      fill="white"
      stroke="black"
      {...props.settings.T43La}
    />
    <path
      id="T43-3"
      d={"M412.0710678118655,304.0710678118655 A10,10 0 0,0 412.0710678118655,289.9289321881345 L419.14213562373095,282.85786437626905 A20,20 0 0,1 419.14213562373095,311.14213562373095 L412.0710678118655,304.0710678118655"}
      fill="white"
      stroke="black"
      {...props.settings.T43M}
    />
    {props.settings.T43?.implant && 
      <g>
      <image href="/static/images/implantTooth.png" x={373} y={265} height="65" width="65"/>
    </g>}

    <circle
      id="T44-5"
      fill="white"
      stroke="black"
      cx={340} 
      cy={297}
      r={23}
      {...props.settings.T44C}
    />
    <circle
      id="T44-4"
      fill="white"
      stroke="black"
      cx={340} 
      cy={297}
      r={10}
      {...props.settings.T44O}
    />
       <>
      <rect id="T44-rs"
      x={299}
      y={285}
      width={16} 
      height={24}
      {...props.settings.TS44S45}  
      fill="white"
      stroke="none"
      /> 
      <circle
      id="T44-cs"
      stroke="black"
      cx={307}
      cy={297}
      r={8}
      {...props.settings.TS44S45}
      />
      <text 
        id="T44-ts"
        x={307}
        y={297}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS44S45t}
        >S</text></><>
      <circle
        id="T44-csn"
        stroke="black"
        cx={340}
        cy={264}
        r={8}
        {...props.settings.TS44Li}
      />
      <text 
        id="T44-tsn"
        x={340}
        y={264}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS44Lit}
        >S</text>
      </><>
      <circle
        id="T44-css"
        stroke="black"
        cx={340}
        cy={330}
        r={8}
        {...props.settings.TS44B}
      />
      <text 
        id="T44-tss"
        x={340}
        y={330}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS44Bt}
        >S</text>
      </>
    <path
      id="T44-0"
      d={"M347.0710678118655,289.9289321881345 A10,10 0 0,0 332.9289321881345,289.9289321881345 L325.85786437626905,282.85786437626905 A20,20 0 0,1 354.14213562373095,282.85786437626905 L347.0710678118655,289.9289321881345"}
      fill="white"
      stroke="black"
      {...props.settings.T44Li}
    />
    <path
      id="T44-1"
      d={"M332.9289321881345,289.9289321881345 A10,10 0 0,0 332.9289321881345,304.0710678118655 L325.85786437626905,311.14213562373095 A20,20 0 0,1 325.85786437626905,282.85786437626905 L332.9289321881345,289.9289321881345"}
      fill="white"
      stroke="black"
      {...props.settings.T44D}
    />
    <path
      id="T44-2"
      d={"M332.9289321881345,304.0710678118655 A10,10 0 0,0 347.0710678118655,304.0710678118655 L354.14213562373095,311.14213562373095 A20,20 0 0,1 325.85786437626905,311.14213562373095 L332.9289321881345,304.0710678118655"}
      fill="white"
      stroke="black"
      {...props.settings.T44B}
    />
    <path
      id="T44-3"
      d={"M347.0710678118655,304.0710678118655 A10,10 0 0,0 347.0710678118655,289.9289321881345 L354.14213562373095,282.85786437626905 A20,20 0 0,1 354.14213562373095,311.14213562373095 L347.0710678118655,304.0710678118655"}
      fill="white"
      stroke="black"
      {...props.settings.T44M}
    />
    {props.settings.T44?.implant && 
      <g>
      <image href="/static/images/implantTooth.png" x={308} y={265} height="65" width="65"/>
    </g>}

    <circle
      id="T45-5"
      fill="white"
      stroke="black"
      cx={275} 
      cy={297}
      r={23}
      {...props.settings.T45C}
    />
    <circle
      id="T45-4"
      fill="white"
      stroke="black"
      cx={275} 
      cy={297}
      r={10}
      {...props.settings.T45O}
    />
       <>
      <rect id="T45-rs"
      x={234}
      y={285}
      width={16} 
      height={24}
      {...props.settings.TS45S46}  
      fill="white"
      stroke="none"
      /> 
      <circle
      id="T45-cs"
      stroke="black"
      cx={242}
      cy={297}
      r={8}
      {...props.settings.TS45S46}
      />
      <text 
        id="T45-ts"
        x={242}
        y={297}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS45S46t}
        >S</text></><>
      <circle
        id="T45-csn"
        stroke="black"
        cx={275}
        cy={264}
        r={8}
        {...props.settings.TS45Li}
      />
      <text 
        id="T45-tsn"
        x={275}
        y={264}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS45Lit}
        >S</text>
      </><>
      <circle
        id="T45-css"
        stroke="black"
        cx={275}
        cy={330}
        r={8}
        {...props.settings.TS45B}
      />
      <text 
        id="T45-tss"
        x={275}
        y={330}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS45Bt}
        >S</text>
      </>
    <path
      id="T45-0"
      d={"M282.0710678118655,289.9289321881345 A10,10 0 0,0 267.9289321881345,289.9289321881345 L260.85786437626905,282.85786437626905 A20,20 0 0,1 289.14213562373095,282.85786437626905 L282.0710678118655,289.9289321881345"}
      fill="white"
      stroke="black"
      {...props.settings.T45Li}
    />
    <path
      id="T45-1"
      d={"M267.9289321881345,289.9289321881345 A10,10 0 0,0 267.9289321881345,304.0710678118655 L260.85786437626905,311.14213562373095 A20,20 0 0,1 260.85786437626905,282.85786437626905 L267.9289321881345,289.9289321881345"}
      fill="white"
      stroke="black"
      {...props.settings.T45D}
    />
    <path
      id="T45-2"
      d={"M267.9289321881345,304.0710678118655 A10,10 0 0,0 282.0710678118655,304.0710678118655 L289.14213562373095,311.14213562373095 A20,20 0 0,1 260.85786437626905,311.14213562373095 L267.9289321881345,304.0710678118655"}
      fill="white"
      stroke="black"
      {...props.settings.T45B}
    />
    <path
      id="T45-3"
      d={"M282.0710678118655,304.0710678118655 A10,10 0 0,0 282.0710678118655,289.9289321881345 L289.14213562373095,282.85786437626905 A20,20 0 0,1 289.14213562373095,311.14213562373095 L282.0710678118655,304.0710678118655"}
      fill="white"
      stroke="black"
      {...props.settings.T45M}
    />
    {props.settings.T45?.implant && 
      <g>
      <image href="/static/images/implantTooth.png" x={243} y={265} height="65" width="65"/>
    </g>}

    <circle
      id="T46-5"
      fill="white"
      stroke="black"
      cx={210} 
      cy={297}
      r={23}
      {...props.settings.T46C}
    />
    <circle
      id="T46-4"
      fill="white"
      stroke="black"
      cx={210} 
      cy={297}
      r={10}
      {...props.settings.T46O}
    />
       <>
      <rect id="T46-rs"
      x={169}
      y={285}
      width={16} 
      height={24}
      {...props.settings.TS46S47}  
      fill="white"
      stroke="none"
      /> 
      <circle
      id="T46-cs"
      stroke="black"
      cx={177}
      cy={297}
      r={8}
      {...props.settings.TS46S47}
      />
      <text 
        id="T46-ts"
        x={177}
        y={297}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS46S47t}
        >S</text></><>
      <circle
        id="T46-csn"
        stroke="black"
        cx={210}
        cy={264}
        r={8}
        {...props.settings.TS46Li}
      />
      <text 
        id="T46-tsn"
        x={210}
        y={264}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS46Lit}
        >S</text>
      </><>
      <circle
        id="T46-css"
        stroke="black"
        cx={210}
        cy={330}
        r={8}
        {...props.settings.TS46B}
      />
      <text 
        id="T46-tss"
        x={210}
        y={330}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS46Bt}
        >S</text>
      </>
    <path
      id="T46-0"
      d={"M217.07106781186548,289.9289321881345 A10,10 0 0,0 202.92893218813452,289.9289321881345 L195.85786437626905,282.85786437626905 A20,20 0 0,1 224.14213562373095,282.85786437626905 L217.07106781186548,289.9289321881345"}
      fill="white"
      stroke="black"
      {...props.settings.T46Li}
    />
    <path
      id="T46-1"
      d={"M202.92893218813452,289.9289321881345 A10,10 0 0,0 202.92893218813452,304.0710678118655 L195.85786437626905,311.14213562373095 A20,20 0 0,1 195.85786437626905,282.85786437626905 L202.92893218813452,289.9289321881345"}
      fill="white"
      stroke="black"
      {...props.settings.T46D}
    />
    <path
      id="T46-2"
      d={"M202.92893218813452,304.0710678118655 A10,10 0 0,0 217.07106781186548,304.0710678118655 L224.14213562373095,311.14213562373095 A20,20 0 0,1 195.85786437626905,311.14213562373095 L202.92893218813452,304.0710678118655"}
      fill="white"
      stroke="black"
      {...props.settings.T46B}
    />
    <path
      id="T46-3"
      d={"M217.07106781186548,304.0710678118655 A10,10 0 0,0 217.07106781186548,289.9289321881345 L224.14213562373095,282.85786437626905 A20,20 0 0,1 224.14213562373095,311.14213562373095 L217.07106781186548,304.0710678118655"}
      fill="white"
      stroke="black"
      {...props.settings.T46M}
    />
    {props.settings.T46?.implant && 
      <g>
      <image href="/static/images/implantTooth.png" x={178} y={265} height="65" width="65"/>
    </g>}

    <circle
      id="T47-5"
      fill="white"
      stroke="black"
      cx={145} 
      cy={297}
      r={23}
      {...props.settings.T47C}
    />
    <circle
      id="T47-4"
      fill="white"
      stroke="black"
      cx={145} 
      cy={297}
      r={10}
      {...props.settings.T47O}
    />
       <>
      <rect id="T47-rs"
      x={104}
      y={285}
      width={16} 
      height={24}
      {...props.settings.TS47S48}  
      fill="white"
      stroke="none"
      /> 
      <circle
      id="T47-cs"
      stroke="black"
      cx={112}
      cy={297}
      r={8}
      {...props.settings.TS47S48}
      />
      <text 
        id="T47-ts"
        x={112}
        y={297}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS47S48t}
        >S</text></><>
      <circle
        id="T47-csn"
        stroke="black"
        cx={145}
        cy={264}
        r={8}
        {...props.settings.TS47Li}
      />
      <text 
        id="T47-tsn"
        x={145}
        y={264}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS47Lit}
        >S</text>
      </><>
      <circle
        id="T47-css"
        stroke="black"
        cx={145}
        cy={330}
        r={8}
        {...props.settings.TS47B}
      />
      <text 
        id="T47-tss"
        x={145}
        y={330}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS47Bt}
        >S</text>
      </>
    <path
      id="T47-0"
      d={"M152.07106781186548,289.9289321881345 A10,10 0 0,0 137.92893218813452,289.9289321881345 L130.85786437626905,282.85786437626905 A20,20 0 0,1 159.14213562373095,282.85786437626905 L152.07106781186548,289.9289321881345"}
      fill="white"
      stroke="black"
      {...props.settings.T47Li}
    />
    <path
      id="T47-1"
      d={"M137.92893218813452,289.9289321881345 A10,10 0 0,0 137.92893218813452,304.0710678118655 L130.85786437626905,311.14213562373095 A20,20 0 0,1 130.85786437626905,282.85786437626905 L137.92893218813452,289.9289321881345"}
      fill="white"
      stroke="black"
      {...props.settings.T47D}
    />
    <path
      id="T47-2"
      d={"M137.92893218813452,304.0710678118655 A10,10 0 0,0 152.07106781186548,304.0710678118655 L159.14213562373095,311.14213562373095 A20,20 0 0,1 130.85786437626905,311.14213562373095 L137.92893218813452,304.0710678118655"}
      fill="white"
      stroke="black"
      {...props.settings.T47B}
    />
    <path
      id="T47-3"
      d={"M152.07106781186548,304.0710678118655 A10,10 0 0,0 152.07106781186548,289.9289321881345 L159.14213562373095,282.85786437626905 A20,20 0 0,1 159.14213562373095,311.14213562373095 L152.07106781186548,304.0710678118655"}
      fill="white"
      stroke="black"
      {...props.settings.T47M}
    />
    {props.settings.T47?.implant && 
      <g>
      <image href="/static/images/implantTooth.png" x={113} y={265} height="65" width="65"/>
    </g>}

    <circle
      id="T48-5"
      fill="white"
      stroke="black"
      cx={80} 
      cy={297}
      r={23}
      {...props.settings.T48C}
    />
    <circle
      id="T48-4"
      fill="white"
      stroke="black"
      cx={80} 
      cy={297}
      r={10}
      {...props.settings.T48O}
    />
       <>
      <rect id="T48-rs"
      x={39}
      y={285}
      width={16} 
      height={24}
      {...props.settings.TS48D}  
      fill="white"
      stroke="none"
      /> 
      <circle
      id="T48-cs"
      stroke="black"
      cx={47}
      cy={297}
      r={8}
      {...props.settings.TS48D}
      />
      <text 
        id="T48-ts"
        x={47}
        y={297}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS48Dt}
        >S</text></><>
      <circle
        id="T48-csn"
        stroke="black"
        cx={80}
        cy={264}
        r={8}
        {...props.settings.TS48Li}
      />
      <text 
        id="T48-tsn"
        x={80}
        y={264}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS48Lit}
        >S</text>
      </><>
      <circle
        id="T48-css"
        stroke="black"
        cx={80}
        cy={330}
        r={8}
        {...props.settings.TS48B}
      />
      <text 
        id="T48-tss"
        x={80}
        y={330}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="white"
        {...props.settings.TS48Bt}
        >S</text>
      </>
    <path
      id="T48-0"
      d={"M87.07106781186548,289.9289321881345 A10,10 0 0,0 72.92893218813452,289.9289321881345 L65.85786437626905,282.85786437626905 A20,20 0 0,1 94.14213562373095,282.85786437626905 L87.07106781186548,289.9289321881345"}
      fill="white"
      stroke="black"
      {...props.settings.T48Li}
    />
    <path
      id="T48-1"
      d={"M72.92893218813452,289.9289321881345 A10,10 0 0,0 72.92893218813452,304.0710678118655 L65.85786437626905,311.14213562373095 A20,20 0 0,1 65.85786437626905,282.85786437626905 L72.92893218813452,289.9289321881345"}
      fill="white"
      stroke="black"
      {...props.settings.T48D}
    />
    <path
      id="T48-2"
      d={"M72.92893218813452,304.0710678118655 A10,10 0 0,0 87.07106781186548,304.0710678118655 L94.14213562373095,311.14213562373095 A20,20 0 0,1 65.85786437626905,311.14213562373095 L72.92893218813452,304.0710678118655"}
      fill="white"
      stroke="black"
      {...props.settings.T48B}
    />
    <path
      id="T48-3"
      d={"M87.07106781186548,304.0710678118655 A10,10 0 0,0 87.07106781186548,289.9289321881345 L94.14213562373095,282.85786437626905 A20,20 0 0,1 94.14213562373095,311.14213562373095 L87.07106781186548,304.0710678118655"}
      fill="white"
      stroke="black"
      {...props.settings.T48M}
    />
    {props.settings.T48?.implant && 
      <g>
      <image href="/static/images/implantTooth.png" x={48} y={265} height="65" width="65"/>
    </g>}

    <circle
      id="T51-5"
      fill="white"
      stroke="black"
      cx={535} 
      cy={129}
      r={23}
      {...props.settings.T51C}
    />
    <circle
      id="T51-4"
      fill="white"
      stroke="black"
      cx={535} 
      cy={129}
      r={10}
      {...props.settings.T51I}
    />
    
    <path
      id="T51-0"
      d={"M542.0710678118655,121.92893218813452 A10,10 0 0,0 527.9289321881346,121.92893218813452 L520.857864376269,114.85786437626905 A20,20 0 0,1 549.142135623731,114.85786437626905 L542.0710678118655,121.92893218813452"}
      fill="white"
      stroke="black"
      {...props.settings.T51La}
    />
    <path
      id="T51-1"
      d={"M527.9289321881346,121.92893218813452 A10,10 0 0,0 527.9289321881345,136.07106781186548 L520.857864376269,143.14213562373095 A20,20 0 0,1 520.857864376269,114.85786437626905 L527.9289321881346,121.92893218813452"}
      fill="white"
      stroke="black"
      {...props.settings.T51D}
    />
    <path
      id="T51-2"
      d={"M527.9289321881345,136.07106781186548 A10,10 0 0,0 542.0710678118654,136.07106781186548 L549.142135623731,143.14213562373095 A20,20 0 0,1 520.857864376269,143.14213562373095 L527.9289321881345,136.07106781186548"}
      fill="white"
      stroke="black"
      {...props.settings.T51Pa}
    />
    <path
      id="T51-3"
      d={"M542.0710678118654,136.07106781186548 A10,10 0 0,0 542.0710678118655,121.92893218813452 L549.142135623731,114.85786437626905 A20,20 0 0,1 549.142135623731,143.14213562373095 L542.0710678118654,136.07106781186548"}
      fill="white"
      stroke="black"
      {...props.settings.T51M}
    />
    {props.settings.T51?.implant && 
      <g>
      <image href="/static/images/implantTooth.png" x={503} y={97} height="65" width="65"/>
    </g>}

    <circle
      id="T52-5"
      fill="white"
      stroke="black"
      cx={470} 
      cy={129}
      r={23}
      {...props.settings.T52C}
    />
    <circle
      id="T52-4"
      fill="white"
      stroke="black"
      cx={470} 
      cy={129}
      r={10}
      {...props.settings.T52I}
    />
    
    <path
      id="T52-0"
      d={"M477.0710678118655,121.92893218813452 A10,10 0 0,0 462.9289321881345,121.92893218813452 L455.85786437626905,114.85786437626905 A20,20 0 0,1 484.14213562373095,114.85786437626905 L477.0710678118655,121.92893218813452"}
      fill="white"
      stroke="black"
      {...props.settings.T52La}
    />
    <path
      id="T52-1"
      d={"M462.9289321881345,121.92893218813452 A10,10 0 0,0 462.9289321881345,136.07106781186548 L455.85786437626905,143.14213562373095 A20,20 0 0,1 455.85786437626905,114.85786437626905 L462.9289321881345,121.92893218813452"}
      fill="white"
      stroke="black"
      {...props.settings.T52D}
    />
    <path
      id="T52-2"
      d={"M462.9289321881345,136.07106781186548 A10,10 0 0,0 477.0710678118655,136.07106781186548 L484.14213562373095,143.14213562373095 A20,20 0 0,1 455.85786437626905,143.14213562373095 L462.9289321881345,136.07106781186548"}
      fill="white"
      stroke="black"
      {...props.settings.T52Pa}
    />
    <path
      id="T52-3"
      d={"M477.0710678118655,136.07106781186548 A10,10 0 0,0 477.0710678118655,121.92893218813452 L484.14213562373095,114.85786437626905 A20,20 0 0,1 484.14213562373095,143.14213562373095 L477.0710678118655,136.07106781186548"}
      fill="white"
      stroke="black"
      {...props.settings.T52M}
    />
    {props.settings.T52?.implant && 
      <g>
      <image href="/static/images/implantTooth.png" x={438} y={97} height="65" width="65"/>
    </g>}

    <circle
      id="T53-5"
      fill="white"
      stroke="black"
      cx={405} 
      cy={129}
      r={23}
      {...props.settings.T53C}
    />
    <circle
      id="T53-4"
      fill="white"
      stroke="black"
      cx={405} 
      cy={129}
      r={10}
      {...props.settings.T53I}
    />
    
    <path
      id="T53-0"
      d={"M412.0710678118655,121.92893218813452 A10,10 0 0,0 397.9289321881345,121.92893218813452 L390.85786437626905,114.85786437626905 A20,20 0 0,1 419.14213562373095,114.85786437626905 L412.0710678118655,121.92893218813452"}
      fill="white"
      stroke="black"
      {...props.settings.T53La}
    />
    <path
      id="T53-1"
      d={"M397.9289321881345,121.92893218813452 A10,10 0 0,0 397.9289321881345,136.07106781186548 L390.85786437626905,143.14213562373095 A20,20 0 0,1 390.85786437626905,114.85786437626905 L397.9289321881345,121.92893218813452"}
      fill="white"
      stroke="black"
      {...props.settings.T53D}
    />
    <path
      id="T53-2"
      d={"M397.9289321881345,136.07106781186548 A10,10 0 0,0 412.0710678118655,136.07106781186548 L419.14213562373095,143.14213562373095 A20,20 0 0,1 390.85786437626905,143.14213562373095 L397.9289321881345,136.07106781186548"}
      fill="white"
      stroke="black"
      {...props.settings.T53Pa}
    />
    <path
      id="T53-3"
      d={"M412.0710678118655,136.07106781186548 A10,10 0 0,0 412.0710678118655,121.92893218813452 L419.14213562373095,114.85786437626905 A20,20 0 0,1 419.14213562373095,143.14213562373095 L412.0710678118655,136.07106781186548"}
      fill="white"
      stroke="black"
      {...props.settings.T53M}
    />
    {props.settings.T53?.implant && 
      <g>
      <image href="/static/images/implantTooth.png" x={373} y={97} height="65" width="65"/>
    </g>}

    <circle
      id="T54-5"
      fill="white"
      stroke="black"
      cx={340} 
      cy={129}
      r={23}
      {...props.settings.T54C}
    />
    <circle
      id="T54-4"
      fill="white"
      stroke="black"
      cx={340} 
      cy={129}
      r={10}
      {...props.settings.T54O}
    />
    
    <path
      id="T54-0"
      d={"M347.0710678118655,121.92893218813452 A10,10 0 0,0 332.9289321881345,121.92893218813452 L325.85786437626905,114.85786437626905 A20,20 0 0,1 354.14213562373095,114.85786437626905 L347.0710678118655,121.92893218813452"}
      fill="white"
      stroke="black"
      {...props.settings.T54B}
    />
    <path
      id="T54-1"
      d={"M332.9289321881345,121.92893218813452 A10,10 0 0,0 332.9289321881345,136.07106781186548 L325.85786437626905,143.14213562373095 A20,20 0 0,1 325.85786437626905,114.85786437626905 L332.9289321881345,121.92893218813452"}
      fill="white"
      stroke="black"
      {...props.settings.T54D}
    />
    <path
      id="T54-2"
      d={"M332.9289321881345,136.07106781186548 A10,10 0 0,0 347.0710678118655,136.07106781186548 L354.14213562373095,143.14213562373095 A20,20 0 0,1 325.85786437626905,143.14213562373095 L332.9289321881345,136.07106781186548"}
      fill="white"
      stroke="black"
      {...props.settings.T54Pa}
    />
    <path
      id="T54-3"
      d={"M347.0710678118655,136.07106781186548 A10,10 0 0,0 347.0710678118655,121.92893218813452 L354.14213562373095,114.85786437626905 A20,20 0 0,1 354.14213562373095,143.14213562373095 L347.0710678118655,136.07106781186548"}
      fill="white"
      stroke="black"
      {...props.settings.T54M}
    />
    {props.settings.T54?.implant && 
      <g>
      <image href="/static/images/implantTooth.png" x={308} y={97} height="65" width="65"/>
    </g>}

    <circle
      id="T55-5"
      fill="white"
      stroke="black"
      cx={275} 
      cy={129}
      r={23}
      {...props.settings.T55C}
    />
    <circle
      id="T55-4"
      fill="white"
      stroke="black"
      cx={275} 
      cy={129}
      r={10}
      {...props.settings.T55O}
    />
    
    <path
      id="T55-0"
      d={"M282.0710678118655,121.92893218813452 A10,10 0 0,0 267.9289321881345,121.92893218813452 L260.85786437626905,114.85786437626905 A20,20 0 0,1 289.14213562373095,114.85786437626905 L282.0710678118655,121.92893218813452"}
      fill="white"
      stroke="black"
      {...props.settings.T55B}
    />
    <path
      id="T55-1"
      d={"M267.9289321881345,121.92893218813452 A10,10 0 0,0 267.9289321881345,136.07106781186548 L260.85786437626905,143.14213562373095 A20,20 0 0,1 260.85786437626905,114.85786437626905 L267.9289321881345,121.92893218813452"}
      fill="white"
      stroke="black"
      {...props.settings.T55D}
    />
    <path
      id="T55-2"
      d={"M267.9289321881345,136.07106781186548 A10,10 0 0,0 282.0710678118655,136.07106781186548 L289.14213562373095,143.14213562373095 A20,20 0 0,1 260.85786437626905,143.14213562373095 L267.9289321881345,136.07106781186548"}
      fill="white"
      stroke="black"
      {...props.settings.T55Pa}
    />
    <path
      id="T55-3"
      d={"M282.0710678118655,136.07106781186548 A10,10 0 0,0 282.0710678118655,121.92893218813452 L289.14213562373095,114.85786437626905 A20,20 0 0,1 289.14213562373095,143.14213562373095 L282.0710678118655,136.07106781186548"}
      fill="white"
      stroke="black"
      {...props.settings.T55M}
    />
    {props.settings.T55?.implant && 
      <g>
      <image href="/static/images/implantTooth.png" x={243} y={97} height="65" width="65"/>
    </g>}

    <circle
      id="T61-5"
      fill="white"
      stroke="black"
      cx={665} 
      cy={129}
      r={23}
      {...props.settings.T61C}
    />
    <circle
      id="T61-4"
      fill="white"
      stroke="black"
      cx={665} 
      cy={129}
      r={10}
      {...props.settings.T61I}
    />
    
    <path
      id="T61-0"
      d={"M672.0710678118655,121.92893218813452 A10,10 0 0,0 657.9289321881346,121.92893218813452 L650.857864376269,114.85786437626905 A20,20 0 0,1 679.142135623731,114.85786437626905 L672.0710678118655,121.92893218813452"}
      fill="white"
      stroke="black"
      {...props.settings.T61La}
    />
    <path
      id="T61-1"
      d={"M657.9289321881346,121.92893218813452 A10,10 0 0,0 657.9289321881345,136.07106781186548 L650.857864376269,143.14213562373095 A20,20 0 0,1 650.857864376269,114.85786437626905 L657.9289321881346,121.92893218813452"}
      fill="white"
      stroke="black"
      {...props.settings.T61M}
    />
    <path
      id="T61-2"
      d={"M657.9289321881345,136.07106781186548 A10,10 0 0,0 672.0710678118654,136.07106781186548 L679.142135623731,143.14213562373095 A20,20 0 0,1 650.857864376269,143.14213562373095 L657.9289321881345,136.07106781186548"}
      fill="white"
      stroke="black"
      {...props.settings.T61Pa}
    />
    <path
      id="T61-3"
      d={"M672.0710678118654,136.07106781186548 A10,10 0 0,0 672.0710678118655,121.92893218813452 L679.142135623731,114.85786437626905 A20,20 0 0,1 679.142135623731,143.14213562373095 L672.0710678118654,136.07106781186548"}
      fill="white"
      stroke="black"
      {...props.settings.T61D}
    />
    {props.settings.T61?.implant && 
      <g>
      <image href="/static/images/implantTooth.png" x={633} y={97} height="65" width="65"/>
    </g>}

    <circle
      id="T62-5"
      fill="white"
      stroke="black"
      cx={730} 
      cy={129}
      r={23}
      {...props.settings.T62C}
    />
    <circle
      id="T62-4"
      fill="white"
      stroke="black"
      cx={730} 
      cy={129}
      r={10}
      {...props.settings.T62I}
    />
    
    <path
      id="T62-0"
      d={"M737.0710678118655,121.92893218813452 A10,10 0 0,0 722.9289321881346,121.92893218813452 L715.857864376269,114.85786437626905 A20,20 0 0,1 744.142135623731,114.85786437626905 L737.0710678118655,121.92893218813452"}
      fill="white"
      stroke="black"
      {...props.settings.T62La}
    />
    <path
      id="T62-1"
      d={"M722.9289321881346,121.92893218813452 A10,10 0 0,0 722.9289321881345,136.07106781186548 L715.857864376269,143.14213562373095 A20,20 0 0,1 715.857864376269,114.85786437626905 L722.9289321881346,121.92893218813452"}
      fill="white"
      stroke="black"
      {...props.settings.T62M}
    />
    <path
      id="T62-2"
      d={"M722.9289321881345,136.07106781186548 A10,10 0 0,0 737.0710678118654,136.07106781186548 L744.142135623731,143.14213562373095 A20,20 0 0,1 715.857864376269,143.14213562373095 L722.9289321881345,136.07106781186548"}
      fill="white"
      stroke="black"
      {...props.settings.T62Pa}
    />
    <path
      id="T62-3"
      d={"M737.0710678118654,136.07106781186548 A10,10 0 0,0 737.0710678118655,121.92893218813452 L744.142135623731,114.85786437626905 A20,20 0 0,1 744.142135623731,143.14213562373095 L737.0710678118654,136.07106781186548"}
      fill="white"
      stroke="black"
      {...props.settings.T62D}
    />
    {props.settings.T62?.implant && 
      <g>
      <image href="/static/images/implantTooth.png" x={698} y={97} height="65" width="65"/>
    </g>}

    <circle
      id="T63-5"
      fill="white"
      stroke="black"
      cx={795} 
      cy={129}
      r={23}
      {...props.settings.T63C}
    />
    <circle
      id="T63-4"
      fill="white"
      stroke="black"
      cx={795} 
      cy={129}
      r={10}
      {...props.settings.T63I}
    />
    
    <path
      id="T63-0"
      d={"M802.0710678118655,121.92893218813452 A10,10 0 0,0 787.9289321881346,121.92893218813452 L780.857864376269,114.85786437626905 A20,20 0 0,1 809.142135623731,114.85786437626905 L802.0710678118655,121.92893218813452"}
      fill="white"
      stroke="black"
      {...props.settings.T63La}
    />
    <path
      id="T63-1"
      d={"M787.9289321881346,121.92893218813452 A10,10 0 0,0 787.9289321881345,136.07106781186548 L780.857864376269,143.14213562373095 A20,20 0 0,1 780.857864376269,114.85786437626905 L787.9289321881346,121.92893218813452"}
      fill="white"
      stroke="black"
      {...props.settings.T63M}
    />
    <path
      id="T63-2"
      d={"M787.9289321881345,136.07106781186548 A10,10 0 0,0 802.0710678118654,136.07106781186548 L809.142135623731,143.14213562373095 A20,20 0 0,1 780.857864376269,143.14213562373095 L787.9289321881345,136.07106781186548"}
      fill="white"
      stroke="black"
      {...props.settings.T63Pa}
    />
    <path
      id="T63-3"
      d={"M802.0710678118654,136.07106781186548 A10,10 0 0,0 802.0710678118655,121.92893218813452 L809.142135623731,114.85786437626905 A20,20 0 0,1 809.142135623731,143.14213562373095 L802.0710678118654,136.07106781186548"}
      fill="white"
      stroke="black"
      {...props.settings.T63D}
    />
    {props.settings.T63?.implant && 
      <g>
      <image href="/static/images/implantTooth.png" x={763} y={97} height="65" width="65"/>
    </g>}

    <circle
      id="T64-5"
      fill="white"
      stroke="black"
      cx={860} 
      cy={129}
      r={23}
      {...props.settings.T64C}
    />
    <circle
      id="T64-4"
      fill="white"
      stroke="black"
      cx={860} 
      cy={129}
      r={10}
      {...props.settings.T64O}
    />
    
    <path
      id="T64-0"
      d={"M867.0710678118655,121.92893218813452 A10,10 0 0,0 852.9289321881346,121.92893218813452 L845.857864376269,114.85786437626905 A20,20 0 0,1 874.142135623731,114.85786437626905 L867.0710678118655,121.92893218813452"}
      fill="white"
      stroke="black"
      {...props.settings.T64B}
    />
    <path
      id="T64-1"
      d={"M852.9289321881346,121.92893218813452 A10,10 0 0,0 852.9289321881345,136.07106781186548 L845.857864376269,143.14213562373095 A20,20 0 0,1 845.857864376269,114.85786437626905 L852.9289321881346,121.92893218813452"}
      fill="white"
      stroke="black"
      {...props.settings.T64M}
    />
    <path
      id="T64-2"
      d={"M852.9289321881345,136.07106781186548 A10,10 0 0,0 867.0710678118654,136.07106781186548 L874.142135623731,143.14213562373095 A20,20 0 0,1 845.857864376269,143.14213562373095 L852.9289321881345,136.07106781186548"}
      fill="white"
      stroke="black"
      {...props.settings.T64Pa}
    />
    <path
      id="T64-3"
      d={"M867.0710678118654,136.07106781186548 A10,10 0 0,0 867.0710678118655,121.92893218813452 L874.142135623731,114.85786437626905 A20,20 0 0,1 874.142135623731,143.14213562373095 L867.0710678118654,136.07106781186548"}
      fill="white"
      stroke="black"
      {...props.settings.T64D}
    />
    {props.settings.T64?.implant && 
      <g>
      <image href="/static/images/implantTooth.png" x={828} y={97} height="65" width="65"/>
    </g>}

    <circle
      id="T65-5"
      fill="white"
      stroke="black"
      cx={925} 
      cy={129}
      r={23}
      {...props.settings.T65C}
    />
    <circle
      id="T65-4"
      fill="white"
      stroke="black"
      cx={925} 
      cy={129}
      r={10}
      {...props.settings.T65O}
    />
    
    <path
      id="T65-0"
      d={"M932.0710678118655,121.92893218813452 A10,10 0 0,0 917.9289321881346,121.92893218813452 L910.857864376269,114.85786437626905 A20,20 0 0,1 939.142135623731,114.85786437626905 L932.0710678118655,121.92893218813452"}
      fill="white"
      stroke="black"
      {...props.settings.T65B}
    />
    <path
      id="T65-1"
      d={"M917.9289321881346,121.92893218813452 A10,10 0 0,0 917.9289321881345,136.07106781186548 L910.857864376269,143.14213562373095 A20,20 0 0,1 910.857864376269,114.85786437626905 L917.9289321881346,121.92893218813452"}
      fill="white"
      stroke="black"
      {...props.settings.T65M}
    />
    <path
      id="T65-2"
      d={"M917.9289321881345,136.07106781186548 A10,10 0 0,0 932.0710678118654,136.07106781186548 L939.142135623731,143.14213562373095 A20,20 0 0,1 910.857864376269,143.14213562373095 L917.9289321881345,136.07106781186548"}
      fill="white"
      stroke="black"
      {...props.settings.T65Pa}
    />
    <path
      id="T65-3"
      d={"M932.0710678118654,136.07106781186548 A10,10 0 0,0 932.0710678118655,121.92893218813452 L939.142135623731,114.85786437626905 A20,20 0 0,1 939.142135623731,143.14213562373095 L932.0710678118654,136.07106781186548"}
      fill="white"
      stroke="black"
      {...props.settings.T65D}
    />
    {props.settings.T65?.implant && 
      <g>
      <image href="/static/images/implantTooth.png" x={893} y={97} height="65" width="65"/>
    </g>}

    <circle
      id="T71-5"
      fill="white"
      stroke="black"
      cx={665} 
      cy={213}
      r={23}
      {...props.settings.T71C}
    />
    <circle
      id="T71-4"
      fill="white"
      stroke="black"
      cx={665} 
      cy={213}
      r={10}
      {...props.settings.T71I}
    />
    
    <path
      id="T71-0"
      d={"M672.0710678118655,205.92893218813452 A10,10 0 0,0 657.9289321881346,205.92893218813452 L650.857864376269,198.85786437626905 A20,20 0 0,1 679.142135623731,198.85786437626905 L672.0710678118655,205.92893218813452"}
      fill="white"
      stroke="black"
      {...props.settings.T71Li}
    />
    <path
      id="T71-1"
      d={"M657.9289321881346,205.92893218813452 A10,10 0 0,0 657.9289321881345,220.07106781186548 L650.857864376269,227.14213562373095 A20,20 0 0,1 650.857864376269,198.85786437626905 L657.9289321881346,205.92893218813452"}
      fill="white"
      stroke="black"
      {...props.settings.T71M}
    />
    <path
      id="T71-2"
      d={"M657.9289321881345,220.07106781186548 A10,10 0 0,0 672.0710678118654,220.07106781186548 L679.142135623731,227.14213562373095 A20,20 0 0,1 650.857864376269,227.14213562373095 L657.9289321881345,220.07106781186548"}
      fill="white"
      stroke="black"
      {...props.settings.T71La}
    />
    <path
      id="T71-3"
      d={"M672.0710678118654,220.07106781186548 A10,10 0 0,0 672.0710678118655,205.92893218813452 L679.142135623731,198.85786437626905 A20,20 0 0,1 679.142135623731,227.14213562373095 L672.0710678118654,220.07106781186548"}
      fill="white"
      stroke="black"
      {...props.settings.T71D}
    />
    {props.settings.T71?.implant && 
      <g>
      <image href="/static/images/implantTooth.png" x={633} y={181} height="65" width="65"/>
    </g>}

    <circle
      id="T72-5"
      fill="white"
      stroke="black"
      cx={730} 
      cy={213}
      r={23}
      {...props.settings.T72C}
    />
    <circle
      id="T72-4"
      fill="white"
      stroke="black"
      cx={730} 
      cy={213}
      r={10}
      {...props.settings.T72I}
    />
    
    <path
      id="T72-0"
      d={"M737.0710678118655,205.92893218813452 A10,10 0 0,0 722.9289321881346,205.92893218813452 L715.857864376269,198.85786437626905 A20,20 0 0,1 744.142135623731,198.85786437626905 L737.0710678118655,205.92893218813452"}
      fill="white"
      stroke="black"
      {...props.settings.T72Li}
    />
    <path
      id="T72-1"
      d={"M722.9289321881346,205.92893218813452 A10,10 0 0,0 722.9289321881345,220.07106781186548 L715.857864376269,227.14213562373095 A20,20 0 0,1 715.857864376269,198.85786437626905 L722.9289321881346,205.92893218813452"}
      fill="white"
      stroke="black"
      {...props.settings.T72M}
    />
    <path
      id="T72-2"
      d={"M722.9289321881345,220.07106781186548 A10,10 0 0,0 737.0710678118654,220.07106781186548 L744.142135623731,227.14213562373095 A20,20 0 0,1 715.857864376269,227.14213562373095 L722.9289321881345,220.07106781186548"}
      fill="white"
      stroke="black"
      {...props.settings.T72La}
    />
    <path
      id="T72-3"
      d={"M737.0710678118654,220.07106781186548 A10,10 0 0,0 737.0710678118655,205.92893218813452 L744.142135623731,198.85786437626905 A20,20 0 0,1 744.142135623731,227.14213562373095 L737.0710678118654,220.07106781186548"}
      fill="white"
      stroke="black"
      {...props.settings.T72D}
    />
    {props.settings.T72?.implant && 
      <g>
      <image href="/static/images/implantTooth.png" x={698} y={181} height="65" width="65"/>
    </g>}

    <circle
      id="T73-5"
      fill="white"
      stroke="black"
      cx={795} 
      cy={213}
      r={23}
      {...props.settings.T73C}
    />
    <circle
      id="T73-4"
      fill="white"
      stroke="black"
      cx={795} 
      cy={213}
      r={10}
      {...props.settings.T73I}
    />
    
    <path
      id="T73-0"
      d={"M802.0710678118655,205.92893218813452 A10,10 0 0,0 787.9289321881346,205.92893218813452 L780.857864376269,198.85786437626905 A20,20 0 0,1 809.142135623731,198.85786437626905 L802.0710678118655,205.92893218813452"}
      fill="white"
      stroke="black"
      {...props.settings.T73Li}
    />
    <path
      id="T73-1"
      d={"M787.9289321881346,205.92893218813452 A10,10 0 0,0 787.9289321881345,220.07106781186548 L780.857864376269,227.14213562373095 A20,20 0 0,1 780.857864376269,198.85786437626905 L787.9289321881346,205.92893218813452"}
      fill="white"
      stroke="black"
      {...props.settings.T73M}
    />
    <path
      id="T73-2"
      d={"M787.9289321881345,220.07106781186548 A10,10 0 0,0 802.0710678118654,220.07106781186548 L809.142135623731,227.14213562373095 A20,20 0 0,1 780.857864376269,227.14213562373095 L787.9289321881345,220.07106781186548"}
      fill="white"
      stroke="black"
      {...props.settings.T73La}
    />
    <path
      id="T73-3"
      d={"M802.0710678118654,220.07106781186548 A10,10 0 0,0 802.0710678118655,205.92893218813452 L809.142135623731,198.85786437626905 A20,20 0 0,1 809.142135623731,227.14213562373095 L802.0710678118654,220.07106781186548"}
      fill="white"
      stroke="black"
      {...props.settings.T73D}
    />
    {props.settings.T73?.implant && 
      <g>
      <image href="/static/images/implantTooth.png" x={763} y={181} height="65" width="65"/>
    </g>}

    <circle
      id="T74-5"
      fill="white"
      stroke="black"
      cx={860} 
      cy={213}
      r={23}
      {...props.settings.T74C}
    />
    <circle
      id="T74-4"
      fill="white"
      stroke="black"
      cx={860} 
      cy={213}
      r={10}
      {...props.settings.T74O}
    />
    
    <path
      id="T74-0"
      d={"M867.0710678118655,205.92893218813452 A10,10 0 0,0 852.9289321881346,205.92893218813452 L845.857864376269,198.85786437626905 A20,20 0 0,1 874.142135623731,198.85786437626905 L867.0710678118655,205.92893218813452"}
      fill="white"
      stroke="black"
      {...props.settings.T74Li}
    />
    <path
      id="T74-1"
      d={"M852.9289321881346,205.92893218813452 A10,10 0 0,0 852.9289321881345,220.07106781186548 L845.857864376269,227.14213562373095 A20,20 0 0,1 845.857864376269,198.85786437626905 L852.9289321881346,205.92893218813452"}
      fill="white"
      stroke="black"
      {...props.settings.T74M}
    />
    <path
      id="T74-2"
      d={"M852.9289321881345,220.07106781186548 A10,10 0 0,0 867.0710678118654,220.07106781186548 L874.142135623731,227.14213562373095 A20,20 0 0,1 845.857864376269,227.14213562373095 L852.9289321881345,220.07106781186548"}
      fill="white"
      stroke="black"
      {...props.settings.T74B}
    />
    <path
      id="T74-3"
      d={"M867.0710678118654,220.07106781186548 A10,10 0 0,0 867.0710678118655,205.92893218813452 L874.142135623731,198.85786437626905 A20,20 0 0,1 874.142135623731,227.14213562373095 L867.0710678118654,220.07106781186548"}
      fill="white"
      stroke="black"
      {...props.settings.T74D}
    />
    {props.settings.T74?.implant && 
      <g>
      <image href="/static/images/implantTooth.png" x={828} y={181} height="65" width="65"/>
    </g>}

    <circle
      id="T75-5"
      fill="white"
      stroke="black"
      cx={925} 
      cy={213}
      r={23}
      {...props.settings.T75C}
    />
    <circle
      id="T75-4"
      fill="white"
      stroke="black"
      cx={925} 
      cy={213}
      r={10}
      {...props.settings.T75O}
    />
    
    <path
      id="T75-0"
      d={"M932.0710678118655,205.92893218813452 A10,10 0 0,0 917.9289321881346,205.92893218813452 L910.857864376269,198.85786437626905 A20,20 0 0,1 939.142135623731,198.85786437626905 L932.0710678118655,205.92893218813452"}
      fill="white"
      stroke="black"
      {...props.settings.T75Li}
    />
    <path
      id="T75-1"
      d={"M917.9289321881346,205.92893218813452 A10,10 0 0,0 917.9289321881345,220.07106781186548 L910.857864376269,227.14213562373095 A20,20 0 0,1 910.857864376269,198.85786437626905 L917.9289321881346,205.92893218813452"}
      fill="white"
      stroke="black"
      {...props.settings.T75M}
    />
    <path
      id="T75-2"
      d={"M917.9289321881345,220.07106781186548 A10,10 0 0,0 932.0710678118654,220.07106781186548 L939.142135623731,227.14213562373095 A20,20 0 0,1 910.857864376269,227.14213562373095 L917.9289321881345,220.07106781186548"}
      fill="white"
      stroke="black"
      {...props.settings.T75B}
    />
    <path
      id="T75-3"
      d={"M932.0710678118654,220.07106781186548 A10,10 0 0,0 932.0710678118655,205.92893218813452 L939.142135623731,198.85786437626905 A20,20 0 0,1 939.142135623731,227.14213562373095 L932.0710678118654,220.07106781186548"}
      fill="white"
      stroke="black"
      {...props.settings.T75D}
    />
    {props.settings.T75?.implant && 
      <g>
      <image href="/static/images/implantTooth.png" x={893} y={181} height="65" width="65"/>
    </g>}

    <circle
      id="T81-5"
      fill="white"
      stroke="black"
      cx={535} 
      cy={213}
      r={23}
      {...props.settings.T81C}
    />
    <circle
      id="T81-4"
      fill="white"
      stroke="black"
      cx={535} 
      cy={213}
      r={10}
      {...props.settings.T81I}
    />
    
    <path
      id="T81-0"
      d={"M542.0710678118655,205.92893218813452 A10,10 0 0,0 527.9289321881346,205.92893218813452 L520.857864376269,198.85786437626905 A20,20 0 0,1 549.142135623731,198.85786437626905 L542.0710678118655,205.92893218813452"}
      fill="white"
      stroke="black"
      {...props.settings.T81Li}
    />
    <path
      id="T81-1"
      d={"M527.9289321881346,205.92893218813452 A10,10 0 0,0 527.9289321881345,220.07106781186548 L520.857864376269,227.14213562373095 A20,20 0 0,1 520.857864376269,198.85786437626905 L527.9289321881346,205.92893218813452"}
      fill="white"
      stroke="black"
      {...props.settings.T81D}
    />
    <path
      id="T81-2"
      d={"M527.9289321881345,220.07106781186548 A10,10 0 0,0 542.0710678118654,220.07106781186548 L549.142135623731,227.14213562373095 A20,20 0 0,1 520.857864376269,227.14213562373095 L527.9289321881345,220.07106781186548"}
      fill="white"
      stroke="black"
      {...props.settings.T81La}
    />
    <path
      id="T81-3"
      d={"M542.0710678118654,220.07106781186548 A10,10 0 0,0 542.0710678118655,205.92893218813452 L549.142135623731,198.85786437626905 A20,20 0 0,1 549.142135623731,227.14213562373095 L542.0710678118654,220.07106781186548"}
      fill="white"
      stroke="black"
      {...props.settings.T81M}
    />
    {props.settings.T81?.implant && 
      <g>
      <image href="/static/images/implantTooth.png" x={503} y={181} height="65" width="65"/>
    </g>}

    <circle
      id="T82-5"
      fill="white"
      stroke="black"
      cx={470} 
      cy={213}
      r={23}
      {...props.settings.T82C}
    />
    <circle
      id="T82-4"
      fill="white"
      stroke="black"
      cx={470} 
      cy={213}
      r={10}
      {...props.settings.T82I}
    />
    
    <path
      id="T82-0"
      d={"M477.0710678118655,205.92893218813452 A10,10 0 0,0 462.9289321881345,205.92893218813452 L455.85786437626905,198.85786437626905 A20,20 0 0,1 484.14213562373095,198.85786437626905 L477.0710678118655,205.92893218813452"}
      fill="white"
      stroke="black"
      {...props.settings.T82Li}
    />
    <path
      id="T82-1"
      d={"M462.9289321881345,205.92893218813452 A10,10 0 0,0 462.9289321881345,220.07106781186548 L455.85786437626905,227.14213562373095 A20,20 0 0,1 455.85786437626905,198.85786437626905 L462.9289321881345,205.92893218813452"}
      fill="white"
      stroke="black"
      {...props.settings.T82D}
    />
    <path
      id="T82-2"
      d={"M462.9289321881345,220.07106781186548 A10,10 0 0,0 477.0710678118655,220.07106781186548 L484.14213562373095,227.14213562373095 A20,20 0 0,1 455.85786437626905,227.14213562373095 L462.9289321881345,220.07106781186548"}
      fill="white"
      stroke="black"
      {...props.settings.T82La}
    />
    <path
      id="T82-3"
      d={"M477.0710678118655,220.07106781186548 A10,10 0 0,0 477.0710678118655,205.92893218813452 L484.14213562373095,198.85786437626905 A20,20 0 0,1 484.14213562373095,227.14213562373095 L477.0710678118655,220.07106781186548"}
      fill="white"
      stroke="black"
      {...props.settings.T82M}
    />
    {props.settings.T82?.implant && 
      <g>
      <image href="/static/images/implantTooth.png" x={438} y={181} height="65" width="65"/>
    </g>}

    <circle
      id="T83-5"
      fill="white"
      stroke="black"
      cx={405} 
      cy={213}
      r={23}
      {...props.settings.T83C}
    />
    <circle
      id="T83-4"
      fill="white"
      stroke="black"
      cx={405} 
      cy={213}
      r={10}
      {...props.settings.T83I}
    />
    
    <path
      id="T83-0"
      d={"M412.0710678118655,205.92893218813452 A10,10 0 0,0 397.9289321881345,205.92893218813452 L390.85786437626905,198.85786437626905 A20,20 0 0,1 419.14213562373095,198.85786437626905 L412.0710678118655,205.92893218813452"}
      fill="white"
      stroke="black"
      {...props.settings.T83Li}
    />
    <path
      id="T83-1"
      d={"M397.9289321881345,205.92893218813452 A10,10 0 0,0 397.9289321881345,220.07106781186548 L390.85786437626905,227.14213562373095 A20,20 0 0,1 390.85786437626905,198.85786437626905 L397.9289321881345,205.92893218813452"}
      fill="white"
      stroke="black"
      {...props.settings.T83D}
    />
    <path
      id="T83-2"
      d={"M397.9289321881345,220.07106781186548 A10,10 0 0,0 412.0710678118655,220.07106781186548 L419.14213562373095,227.14213562373095 A20,20 0 0,1 390.85786437626905,227.14213562373095 L397.9289321881345,220.07106781186548"}
      fill="white"
      stroke="black"
      {...props.settings.T83La}
    />
    <path
      id="T83-3"
      d={"M412.0710678118655,220.07106781186548 A10,10 0 0,0 412.0710678118655,205.92893218813452 L419.14213562373095,198.85786437626905 A20,20 0 0,1 419.14213562373095,227.14213562373095 L412.0710678118655,220.07106781186548"}
      fill="white"
      stroke="black"
      {...props.settings.T83M}
    />
    {props.settings.T83?.implant && 
      <g>
      <image href="/static/images/implantTooth.png" x={373} y={181} height="65" width="65"/>
    </g>}

    <circle
      id="T84-5"
      fill="white"
      stroke="black"
      cx={340} 
      cy={213}
      r={23}
      {...props.settings.T84C}
    />
    <circle
      id="T84-4"
      fill="white"
      stroke="black"
      cx={340} 
      cy={213}
      r={10}
      {...props.settings.T84O}
    />
    
    <path
      id="T84-0"
      d={"M347.0710678118655,205.92893218813452 A10,10 0 0,0 332.9289321881345,205.92893218813452 L325.85786437626905,198.85786437626905 A20,20 0 0,1 354.14213562373095,198.85786437626905 L347.0710678118655,205.92893218813452"}
      fill="white"
      stroke="black"
      {...props.settings.T84Li}
    />
    <path
      id="T84-1"
      d={"M332.9289321881345,205.92893218813452 A10,10 0 0,0 332.9289321881345,220.07106781186548 L325.85786437626905,227.14213562373095 A20,20 0 0,1 325.85786437626905,198.85786437626905 L332.9289321881345,205.92893218813452"}
      fill="white"
      stroke="black"
      {...props.settings.T84D}
    />
    <path
      id="T84-2"
      d={"M332.9289321881345,220.07106781186548 A10,10 0 0,0 347.0710678118655,220.07106781186548 L354.14213562373095,227.14213562373095 A20,20 0 0,1 325.85786437626905,227.14213562373095 L332.9289321881345,220.07106781186548"}
      fill="white"
      stroke="black"
      {...props.settings.T84B}
    />
    <path
      id="T84-3"
      d={"M347.0710678118655,220.07106781186548 A10,10 0 0,0 347.0710678118655,205.92893218813452 L354.14213562373095,198.85786437626905 A20,20 0 0,1 354.14213562373095,227.14213562373095 L347.0710678118655,220.07106781186548"}
      fill="white"
      stroke="black"
      {...props.settings.T84M}
    />
    {props.settings.T84?.implant && 
      <g>
      <image href="/static/images/implantTooth.png" x={308} y={181} height="65" width="65"/>
    </g>}

    <circle
      id="T85-5"
      fill="white"
      stroke="black"
      cx={275} 
      cy={213}
      r={23}
      {...props.settings.T85C}
    />
    <circle
      id="T85-4"
      fill="white"
      stroke="black"
      cx={275} 
      cy={213}
      r={10}
      {...props.settings.T85O}
    />
    
    <path
      id="T85-0"
      d={"M282.0710678118655,205.92893218813452 A10,10 0 0,0 267.9289321881345,205.92893218813452 L260.85786437626905,198.85786437626905 A20,20 0 0,1 289.14213562373095,198.85786437626905 L282.0710678118655,205.92893218813452"}
      fill="white"
      stroke="black"
      {...props.settings.T85Li}
    />
    <path
      id="T85-1"
      d={"M267.9289321881345,205.92893218813452 A10,10 0 0,0 267.9289321881345,220.07106781186548 L260.85786437626905,227.14213562373095 A20,20 0 0,1 260.85786437626905,198.85786437626905 L267.9289321881345,205.92893218813452"}
      fill="white"
      stroke="black"
      {...props.settings.T85D}
    />
    <path
      id="T85-2"
      d={"M267.9289321881345,220.07106781186548 A10,10 0 0,0 282.0710678118655,220.07106781186548 L289.14213562373095,227.14213562373095 A20,20 0 0,1 260.85786437626905,227.14213562373095 L267.9289321881345,220.07106781186548"}
      fill="white"
      stroke="black"
      {...props.settings.T85B}
    />
    <path
      id="T85-3"
      d={"M282.0710678118655,220.07106781186548 A10,10 0 0,0 282.0710678118655,205.92893218813452 L289.14213562373095,198.85786437626905 A20,20 0 0,1 289.14213562373095,227.14213562373095 L282.0710678118655,220.07106781186548"}
      fill="white"
      stroke="black"
      {...props.settings.T85M}
    />
    {props.settings.T85?.implant && 
      <g>
      <image href="/static/images/implantTooth.png" x={243} y={181} height="65" width="65"/>
    </g>}
  </svg>
  )
}
  
export default DentalRecord1

export const HotSpot = [
 {
  "i": 1,
  "q": 1,
  "x": 535,
  "y": 30,
  "location": "11La",
  "key": "T11La"
 },
 {
  "i": 1,
  "q": 1,
  "x": 520,
  "y": 45,
  "location": "11D",
  "key": "T11D"
 },
 {
  "i": 1,
  "q": 1,
  "x": 535,
  "y": 60,
  "location": "11Pa",
  "key": "T11Pa"
 },
 {
  "i": 1,
  "q": 1,
  "x": 550,
  "y": 45,
  "location": "11M",
  "key": "T11M"
 },
 {
  "i": 1,
  "q": 1,
  "x": 535,
  "y": 45,
  "location": "11I",
  "key": "T11I"
 },
 {
  "i": 1,
  "q": 1,
  "x": 502,
  "y": 45,
  "location": "S11S12",
  "key": "TS11S12"
 },
 {
  "i": 1,
  "q": 1,
  "x": 535,
  "y": 78,
  "location": "S11Pa",
  "key": "TS11Pa"
 },
 {
  "i": 1,
  "q": 1,
  "x": 535,
  "y": 12,
  "location": "S11La",
  "key": "TS11La"
 },
 {
  "i": 2,
  "q": 1,
  "x": 470,
  "y": 30,
  "location": "12La",
  "key": "T12La"
 },
 {
  "i": 2,
  "q": 1,
  "x": 455,
  "y": 45,
  "location": "12D",
  "key": "T12D"
 },
 {
  "i": 2,
  "q": 1,
  "x": 470,
  "y": 60,
  "location": "12Pa",
  "key": "T12Pa"
 },
 {
  "i": 2,
  "q": 1,
  "x": 485,
  "y": 45,
  "location": "12M",
  "key": "T12M"
 },
 {
  "i": 2,
  "q": 1,
  "x": 470,
  "y": 45,
  "location": "12I",
  "key": "T12I"
 },
 {
  "i": 2,
  "q": 1,
  "x": 437,
  "y": 45,
  "location": "S12S13",
  "key": "TS12S13"
 },
 {
  "i": 2,
  "q": 1,
  "x": 470,
  "y": 78,
  "location": "S12Pa",
  "key": "TS12Pa"
 },
 {
  "i": 2,
  "q": 1,
  "x": 470,
  "y": 12,
  "location": "S12La",
  "key": "TS12La"
 },
 {
  "i": 3,
  "q": 1,
  "x": 405,
  "y": 30,
  "location": "13La",
  "key": "T13La"
 },
 {
  "i": 3,
  "q": 1,
  "x": 390,
  "y": 45,
  "location": "13D",
  "key": "T13D"
 },
 {
  "i": 3,
  "q": 1,
  "x": 405,
  "y": 60,
  "location": "13Pa",
  "key": "T13Pa"
 },
 {
  "i": 3,
  "q": 1,
  "x": 420,
  "y": 45,
  "location": "13M",
  "key": "T13M"
 },
 {
  "i": 3,
  "q": 1,
  "x": 405,
  "y": 45,
  "location": "13I",
  "key": "T13I"
 },
 {
  "i": 3,
  "q": 1,
  "x": 372,
  "y": 45,
  "location": "S13S14",
  "key": "TS13S14"
 },
 {
  "i": 3,
  "q": 1,
  "x": 405,
  "y": 78,
  "location": "S13Pa",
  "key": "TS13Pa"
 },
 {
  "i": 3,
  "q": 1,
  "x": 405,
  "y": 12,
  "location": "S13La",
  "key": "TS13La"
 },
 {
  "i": 4,
  "q": 1,
  "x": 340,
  "y": 30,
  "location": "14B",
  "key": "T14B"
 },
 {
  "i": 4,
  "q": 1,
  "x": 325,
  "y": 45,
  "location": "14D",
  "key": "T14D"
 },
 {
  "i": 4,
  "q": 1,
  "x": 340,
  "y": 60,
  "location": "14Pa",
  "key": "T14Pa"
 },
 {
  "i": 4,
  "q": 1,
  "x": 355,
  "y": 45,
  "location": "14M",
  "key": "T14M"
 },
 {
  "i": 4,
  "q": 1,
  "x": 340,
  "y": 45,
  "location": "14O",
  "key": "T14O"
 },
 {
  "i": 4,
  "q": 1,
  "x": 307,
  "y": 45,
  "location": "S14S15",
  "key": "TS14S15"
 },
 {
  "i": 4,
  "q": 1,
  "x": 340,
  "y": 78,
  "location": "S14Pa",
  "key": "TS14Pa"
 },
 {
  "i": 4,
  "q": 1,
  "x": 340,
  "y": 12,
  "location": "S14B",
  "key": "TS14B"
 },
 {
  "i": 5,
  "q": 1,
  "x": 275,
  "y": 30,
  "location": "15B",
  "key": "T15B"
 },
 {
  "i": 5,
  "q": 1,
  "x": 260,
  "y": 45,
  "location": "15D",
  "key": "T15D"
 },
 {
  "i": 5,
  "q": 1,
  "x": 275,
  "y": 60,
  "location": "15Pa",
  "key": "T15Pa"
 },
 {
  "i": 5,
  "q": 1,
  "x": 290,
  "y": 45,
  "location": "15M",
  "key": "T15M"
 },
 {
  "i": 5,
  "q": 1,
  "x": 275,
  "y": 45,
  "location": "15O",
  "key": "T15O"
 },
 {
  "i": 5,
  "q": 1,
  "x": 242,
  "y": 45,
  "location": "S15S16",
  "key": "TS15S16"
 },
 {
  "i": 5,
  "q": 1,
  "x": 275,
  "y": 78,
  "location": "S15Pa",
  "key": "TS15Pa"
 },
 {
  "i": 5,
  "q": 1,
  "x": 275,
  "y": 12,
  "location": "S15B",
  "key": "TS15B"
 },
 {
  "i": 6,
  "q": 1,
  "x": 210,
  "y": 30,
  "location": "16B",
  "key": "T16B"
 },
 {
  "i": 6,
  "q": 1,
  "x": 195,
  "y": 45,
  "location": "16D",
  "key": "T16D"
 },
 {
  "i": 6,
  "q": 1,
  "x": 210,
  "y": 60,
  "location": "16Pa",
  "key": "T16Pa"
 },
 {
  "i": 6,
  "q": 1,
  "x": 225,
  "y": 45,
  "location": "16M",
  "key": "T16M"
 },
 {
  "i": 6,
  "q": 1,
  "x": 210,
  "y": 45,
  "location": "16O",
  "key": "T16O"
 },
 {
  "i": 6,
  "q": 1,
  "x": 177,
  "y": 45,
  "location": "S16S17",
  "key": "TS16S17"
 },
 {
  "i": 6,
  "q": 1,
  "x": 210,
  "y": 78,
  "location": "S16Pa",
  "key": "TS16Pa"
 },
 {
  "i": 6,
  "q": 1,
  "x": 210,
  "y": 12,
  "location": "S16B",
  "key": "TS16B"
 },
 {
  "i": 7,
  "q": 1,
  "x": 145,
  "y": 30,
  "location": "17B",
  "key": "T17B"
 },
 {
  "i": 7,
  "q": 1,
  "x": 130,
  "y": 45,
  "location": "17D",
  "key": "T17D"
 },
 {
  "i": 7,
  "q": 1,
  "x": 145,
  "y": 60,
  "location": "17Pa",
  "key": "T17Pa"
 },
 {
  "i": 7,
  "q": 1,
  "x": 160,
  "y": 45,
  "location": "17M",
  "key": "T17M"
 },
 {
  "i": 7,
  "q": 1,
  "x": 145,
  "y": 45,
  "location": "17O",
  "key": "T17O"
 },
 {
  "i": 7,
  "q": 1,
  "x": 112,
  "y": 45,
  "location": "S17S18",
  "key": "TS17S18"
 },
 {
  "i": 7,
  "q": 1,
  "x": 145,
  "y": 78,
  "location": "S17Pa",
  "key": "TS17Pa"
 },
 {
  "i": 7,
  "q": 1,
  "x": 145,
  "y": 12,
  "location": "S17B",
  "key": "TS17B"
 },
 {
  "i": 8,
  "q": 1,
  "x": 80,
  "y": 30,
  "location": "18B",
  "key": "T18B"
 },
 {
  "i": 8,
  "q": 1,
  "x": 65,
  "y": 45,
  "location": "18D",
  "key": "T18D"
 },
 {
  "i": 8,
  "q": 1,
  "x": 80,
  "y": 60,
  "location": "18Pa",
  "key": "T18Pa"
 },
 {
  "i": 8,
  "q": 1,
  "x": 95,
  "y": 45,
  "location": "18M",
  "key": "T18M"
 },
 {
  "i": 8,
  "q": 1,
  "x": 80,
  "y": 45,
  "location": "18O",
  "key": "T18O"
 },
 {
  "i": 8,
  "q": 1,
  "x": 47,
  "y": 45,
  "location": "S18D",
  "key": "TS18D"
 },
 {
  "i": 8,
  "q": 1,
  "x": 80,
  "y": 78,
  "location": "S18Pa",
  "key": "TS18Pa"
 },
 {
  "i": 8,
  "q": 1,
  "x": 80,
  "y": 12,
  "location": "S18B",
  "key": "TS18B"
 },
 {
  "i": 1,
  "q": 2,
  "x": 665,
  "y": 30,
  "location": "21La",
  "key": "T21La"
 },
 {
  "i": 1,
  "q": 2,
  "x": 650,
  "y": 45,
  "location": "21M",
  "key": "T21M"
 },
 {
  "i": 1,
  "q": 2,
  "x": 665,
  "y": 60,
  "location": "21Pa",
  "key": "T21Pa"
 },
 {
  "i": 1,
  "q": 2,
  "x": 680,
  "y": 45,
  "location": "21D",
  "key": "T21D"
 },
 {
  "i": 1,
  "q": 2,
  "x": 665,
  "y": 45,
  "location": "21I",
  "key": "T21I"
 },
 {
  "i": 1,
  "q": 2,
  "x": 601,
  "y": 45,
  "location": "S11S21",
  "key": "TS11S21"
 },
 {
  "i": 1,
  "q": 2,
  "x": 665,
  "y": 78,
  "location": "S21Pa",
  "key": "TS21Pa"
 },
 {
  "i": 1,
  "q": 2,
  "x": 665,
  "y": 12,
  "location": "S21La",
  "key": "TS21La"
 },
 {
  "i": 2,
  "q": 2,
  "x": 730,
  "y": 30,
  "location": "22La",
  "key": "T22La"
 },
 {
  "i": 2,
  "q": 2,
  "x": 715,
  "y": 45,
  "location": "22M",
  "key": "T22M"
 },
 {
  "i": 2,
  "q": 2,
  "x": 730,
  "y": 60,
  "location": "22Pa",
  "key": "T22Pa"
 },
 {
  "i": 2,
  "q": 2,
  "x": 745,
  "y": 45,
  "location": "22D",
  "key": "T22D"
 },
 {
  "i": 2,
  "q": 2,
  "x": 730,
  "y": 45,
  "location": "22I",
  "key": "T22I"
 },
 {
  "i": 2,
  "q": 2,
  "x": 697,
  "y": 45,
  "location": "S21S22",
  "key": "TS21S22"
 },
 {
  "i": 2,
  "q": 2,
  "x": 730,
  "y": 78,
  "location": "S22Pa",
  "key": "TS22Pa"
 },
 {
  "i": 2,
  "q": 2,
  "x": 730,
  "y": 12,
  "location": "S22La",
  "key": "TS22La"
 },
 {
  "i": 3,
  "q": 2,
  "x": 795,
  "y": 30,
  "location": "23La",
  "key": "T23La"
 },
 {
  "i": 3,
  "q": 2,
  "x": 780,
  "y": 45,
  "location": "23M",
  "key": "T23M"
 },
 {
  "i": 3,
  "q": 2,
  "x": 795,
  "y": 60,
  "location": "23Pa",
  "key": "T23Pa"
 },
 {
  "i": 3,
  "q": 2,
  "x": 810,
  "y": 45,
  "location": "23D",
  "key": "T23D"
 },
 {
  "i": 3,
  "q": 2,
  "x": 795,
  "y": 45,
  "location": "23I",
  "key": "T23I"
 },
 {
  "i": 3,
  "q": 2,
  "x": 762,
  "y": 45,
  "location": "S22S23",
  "key": "TS22S23"
 },
 {
  "i": 3,
  "q": 2,
  "x": 795,
  "y": 78,
  "location": "S23Pa",
  "key": "TS23Pa"
 },
 {
  "i": 3,
  "q": 2,
  "x": 795,
  "y": 12,
  "location": "S23La",
  "key": "TS23La"
 },
 {
  "i": 4,
  "q": 2,
  "x": 860,
  "y": 30,
  "location": "24B",
  "key": "T24B"
 },
 {
  "i": 4,
  "q": 2,
  "x": 845,
  "y": 45,
  "location": "24M",
  "key": "T24M"
 },
 {
  "i": 4,
  "q": 2,
  "x": 860,
  "y": 60,
  "location": "24Pa",
  "key": "T24Pa"
 },
 {
  "i": 4,
  "q": 2,
  "x": 875,
  "y": 45,
  "location": "24D",
  "key": "T24D"
 },
 {
  "i": 4,
  "q": 2,
  "x": 860,
  "y": 45,
  "location": "24O",
  "key": "T24O"
 },
 {
  "i": 4,
  "q": 2,
  "x": 827,
  "y": 45,
  "location": "S23S24",
  "key": "TS23S24"
 },
 {
  "i": 4,
  "q": 2,
  "x": 860,
  "y": 78,
  "location": "S24Pa",
  "key": "TS24Pa"
 },
 {
  "i": 4,
  "q": 2,
  "x": 860,
  "y": 12,
  "location": "S24B",
  "key": "TS24B"
 },
 {
  "i": 5,
  "q": 2,
  "x": 925,
  "y": 30,
  "location": "25B",
  "key": "T25B"
 },
 {
  "i": 5,
  "q": 2,
  "x": 910,
  "y": 45,
  "location": "25M",
  "key": "T25M"
 },
 {
  "i": 5,
  "q": 2,
  "x": 925,
  "y": 60,
  "location": "25Pa",
  "key": "T25Pa"
 },
 {
  "i": 5,
  "q": 2,
  "x": 940,
  "y": 45,
  "location": "25D",
  "key": "T25D"
 },
 {
  "i": 5,
  "q": 2,
  "x": 925,
  "y": 45,
  "location": "25O",
  "key": "T25O"
 },
 {
  "i": 5,
  "q": 2,
  "x": 892,
  "y": 45,
  "location": "S24S25",
  "key": "TS24S25"
 },
 {
  "i": 5,
  "q": 2,
  "x": 925,
  "y": 78,
  "location": "S25Pa",
  "key": "TS25Pa"
 },
 {
  "i": 5,
  "q": 2,
  "x": 925,
  "y": 12,
  "location": "S25B",
  "key": "TS25B"
 },
 {
  "i": 6,
  "q": 2,
  "x": 990,
  "y": 30,
  "location": "26B",
  "key": "T26B"
 },
 {
  "i": 6,
  "q": 2,
  "x": 975,
  "y": 45,
  "location": "26M",
  "key": "T26M"
 },
 {
  "i": 6,
  "q": 2,
  "x": 990,
  "y": 60,
  "location": "26Pa",
  "key": "T26Pa"
 },
 {
  "i": 6,
  "q": 2,
  "x": 1005,
  "y": 45,
  "location": "26D",
  "key": "T26D"
 },
 {
  "i": 6,
  "q": 2,
  "x": 990,
  "y": 45,
  "location": "26O",
  "key": "T26O"
 },
 {
  "i": 6,
  "q": 2,
  "x": 957,
  "y": 45,
  "location": "S25S26",
  "key": "TS25S26"
 },
 {
  "i": 6,
  "q": 2,
  "x": 990,
  "y": 78,
  "location": "S26Pa",
  "key": "TS26Pa"
 },
 {
  "i": 6,
  "q": 2,
  "x": 990,
  "y": 12,
  "location": "S26B",
  "key": "TS26B"
 },
 {
  "i": 7,
  "q": 2,
  "x": 1055,
  "y": 30,
  "location": "27B",
  "key": "T27B"
 },
 {
  "i": 7,
  "q": 2,
  "x": 1040,
  "y": 45,
  "location": "27M",
  "key": "T27M"
 },
 {
  "i": 7,
  "q": 2,
  "x": 1055,
  "y": 60,
  "location": "27Pa",
  "key": "T27Pa"
 },
 {
  "i": 7,
  "q": 2,
  "x": 1070,
  "y": 45,
  "location": "27D",
  "key": "T27D"
 },
 {
  "i": 7,
  "q": 2,
  "x": 1055,
  "y": 45,
  "location": "27O",
  "key": "T27O"
 },
 {
  "i": 7,
  "q": 2,
  "x": 1022,
  "y": 45,
  "location": "S26S27",
  "key": "TS26S27"
 },
 {
  "i": 7,
  "q": 2,
  "x": 1055,
  "y": 78,
  "location": "S27Pa",
  "key": "TS27Pa"
 },
 {
  "i": 7,
  "q": 2,
  "x": 1055,
  "y": 12,
  "location": "S27B",
  "key": "TS27B"
 },
 {
  "i": 8,
  "q": 2,
  "x": 1120,
  "y": 30,
  "location": "28B",
  "key": "T28B"
 },
 {
  "i": 8,
  "q": 2,
  "x": 1105,
  "y": 45,
  "location": "28M",
  "key": "T28M"
 },
 {
  "i": 8,
  "q": 2,
  "x": 1120,
  "y": 60,
  "location": "28Pa",
  "key": "T28Pa"
 },
 {
  "i": 8,
  "q": 2,
  "x": 1135,
  "y": 45,
  "location": "28D",
  "key": "T28D"
 },
 {
  "i": 8,
  "q": 2,
  "x": 1120,
  "y": 45,
  "location": "28O",
  "key": "T28O"
 },
 {
  "i": 8,
  "q": 2,
  "x": 1087,
  "y": 45,
  "location": "S27S28",
  "key": "TS27S28"
 },
 {
  "i": 8,
  "q": 2,
  "x": 1120,
  "y": 78,
  "location": "S28Pa",
  "key": "TS28Pa"
 },
 {
  "i": 8,
  "q": 2,
  "x": 1120,
  "y": 12,
  "location": "S28B",
  "key": "TS28B"
 },
 {
  "i": 8,
  "q": 2,
  "x": 1153,
  "y": 45,
  "location": "S28D",
  "key": "TS28D"
 },
 {
  "i": 1,
  "q": 3,
  "x": 665,
  "y": 282,
  "location": "31Li",
  "key": "T31Li"
 },
 {
  "i": 1,
  "q": 3,
  "x": 650,
  "y": 297,
  "location": "31M",
  "key": "T31M"
 },
 {
  "i": 1,
  "q": 3,
  "x": 665,
  "y": 312,
  "location": "31La",
  "key": "T31La"
 },
 {
  "i": 1,
  "q": 3,
  "x": 680,
  "y": 297,
  "location": "31D",
  "key": "T31D"
 },
 {
  "i": 1,
  "q": 3,
  "x": 665,
  "y": 297,
  "location": "31I",
  "key": "T31I"
 },
 {
  "i": 1,
  "q": 3,
  "x": 601,
  "y": 297,
  "location": "S31S41",
  "key": "TS31S41"
 },
 {
  "i": 1,
  "q": 3,
  "x": 665,
  "y": 330,
  "location": "S31La",
  "key": "TS31La"
 },
 {
  "i": 1,
  "q": 3,
  "x": 665,
  "y": 264,
  "location": "S31Li",
  "key": "TS31Li"
 },
 {
  "i": 2,
  "q": 3,
  "x": 730,
  "y": 282,
  "location": "32Li",
  "key": "T32Li"
 },
 {
  "i": 2,
  "q": 3,
  "x": 715,
  "y": 297,
  "location": "32M",
  "key": "T32M"
 },
 {
  "i": 2,
  "q": 3,
  "x": 730,
  "y": 312,
  "location": "32La",
  "key": "T32La"
 },
 {
  "i": 2,
  "q": 3,
  "x": 745,
  "y": 297,
  "location": "32D",
  "key": "T32D"
 },
 {
  "i": 2,
  "q": 3,
  "x": 730,
  "y": 297,
  "location": "32I",
  "key": "T32I"
 },
 {
  "i": 2,
  "q": 3,
  "x": 697,
  "y": 297,
  "location": "S31S32",
  "key": "TS31S32"
 },
 {
  "i": 2,
  "q": 3,
  "x": 730,
  "y": 330,
  "location": "S32La",
  "key": "TS32La"
 },
 {
  "i": 2,
  "q": 3,
  "x": 730,
  "y": 264,
  "location": "S32Li",
  "key": "TS32Li"
 },
 {
  "i": 3,
  "q": 3,
  "x": 795,
  "y": 282,
  "location": "33Li",
  "key": "T33Li"
 },
 {
  "i": 3,
  "q": 3,
  "x": 780,
  "y": 297,
  "location": "33M",
  "key": "T33M"
 },
 {
  "i": 3,
  "q": 3,
  "x": 795,
  "y": 312,
  "location": "33La",
  "key": "T33La"
 },
 {
  "i": 3,
  "q": 3,
  "x": 810,
  "y": 297,
  "location": "33D",
  "key": "T33D"
 },
 {
  "i": 3,
  "q": 3,
  "x": 795,
  "y": 297,
  "location": "33I",
  "key": "T33I"
 },
 {
  "i": 3,
  "q": 3,
  "x": 762,
  "y": 297,
  "location": "S32S33",
  "key": "TS32S33"
 },
 {
  "i": 3,
  "q": 3,
  "x": 795,
  "y": 330,
  "location": "S33La",
  "key": "TS33La"
 },
 {
  "i": 3,
  "q": 3,
  "x": 795,
  "y": 264,
  "location": "S33Li",
  "key": "TS33Li"
 },
 {
  "i": 4,
  "q": 3,
  "x": 860,
  "y": 282,
  "location": "34Li",
  "key": "T34Li"
 },
 {
  "i": 4,
  "q": 3,
  "x": 845,
  "y": 297,
  "location": "34M",
  "key": "T34M"
 },
 {
  "i": 4,
  "q": 3,
  "x": 860,
  "y": 312,
  "location": "34B",
  "key": "T34B"
 },
 {
  "i": 4,
  "q": 3,
  "x": 875,
  "y": 297,
  "location": "34D",
  "key": "T34D"
 },
 {
  "i": 4,
  "q": 3,
  "x": 860,
  "y": 297,
  "location": "34O",
  "key": "T34O"
 },
 {
  "i": 4,
  "q": 3,
  "x": 827,
  "y": 297,
  "location": "S33S34",
  "key": "TS33S34"
 },
 {
  "i": 4,
  "q": 3,
  "x": 860,
  "y": 330,
  "location": "S34B",
  "key": "TS34B"
 },
 {
  "i": 4,
  "q": 3,
  "x": 860,
  "y": 264,
  "location": "S34Li",
  "key": "TS34Li"
 },
 {
  "i": 5,
  "q": 3,
  "x": 925,
  "y": 282,
  "location": "35Li",
  "key": "T35Li"
 },
 {
  "i": 5,
  "q": 3,
  "x": 910,
  "y": 297,
  "location": "35M",
  "key": "T35M"
 },
 {
  "i": 5,
  "q": 3,
  "x": 925,
  "y": 312,
  "location": "35B",
  "key": "T35B"
 },
 {
  "i": 5,
  "q": 3,
  "x": 940,
  "y": 297,
  "location": "35D",
  "key": "T35D"
 },
 {
  "i": 5,
  "q": 3,
  "x": 925,
  "y": 297,
  "location": "35O",
  "key": "T35O"
 },
 {
  "i": 5,
  "q": 3,
  "x": 892,
  "y": 297,
  "location": "S34S35",
  "key": "TS34S35"
 },
 {
  "i": 5,
  "q": 3,
  "x": 925,
  "y": 330,
  "location": "S35B",
  "key": "TS35B"
 },
 {
  "i": 5,
  "q": 3,
  "x": 925,
  "y": 264,
  "location": "S35Li",
  "key": "TS35Li"
 },
 {
  "i": 6,
  "q": 3,
  "x": 990,
  "y": 282,
  "location": "36Li",
  "key": "T36Li"
 },
 {
  "i": 6,
  "q": 3,
  "x": 975,
  "y": 297,
  "location": "36M",
  "key": "T36M"
 },
 {
  "i": 6,
  "q": 3,
  "x": 990,
  "y": 312,
  "location": "36B",
  "key": "T36B"
 },
 {
  "i": 6,
  "q": 3,
  "x": 1005,
  "y": 297,
  "location": "36D",
  "key": "T36D"
 },
 {
  "i": 6,
  "q": 3,
  "x": 990,
  "y": 297,
  "location": "36O",
  "key": "T36O"
 },
 {
  "i": 6,
  "q": 3,
  "x": 957,
  "y": 297,
  "location": "S35S36",
  "key": "TS35S36"
 },
 {
  "i": 6,
  "q": 3,
  "x": 990,
  "y": 330,
  "location": "S36B",
  "key": "TS36B"
 },
 {
  "i": 6,
  "q": 3,
  "x": 990,
  "y": 264,
  "location": "S36Li",
  "key": "TS36Li"
 },
 {
  "i": 7,
  "q": 3,
  "x": 1055,
  "y": 282,
  "location": "37Li",
  "key": "T37Li"
 },
 {
  "i": 7,
  "q": 3,
  "x": 1040,
  "y": 297,
  "location": "37M",
  "key": "T37M"
 },
 {
  "i": 7,
  "q": 3,
  "x": 1055,
  "y": 312,
  "location": "37B",
  "key": "T37B"
 },
 {
  "i": 7,
  "q": 3,
  "x": 1070,
  "y": 297,
  "location": "37D",
  "key": "T37D"
 },
 {
  "i": 7,
  "q": 3,
  "x": 1055,
  "y": 297,
  "location": "37O",
  "key": "T37O"
 },
 {
  "i": 7,
  "q": 3,
  "x": 1022,
  "y": 297,
  "location": "S36S37",
  "key": "TS36S37"
 },
 {
  "i": 7,
  "q": 3,
  "x": 1055,
  "y": 330,
  "location": "S37B",
  "key": "TS37B"
 },
 {
  "i": 7,
  "q": 3,
  "x": 1055,
  "y": 264,
  "location": "S37Li",
  "key": "TS37Li"
 },
 {
  "i": 8,
  "q": 3,
  "x": 1120,
  "y": 282,
  "location": "38Li",
  "key": "T38Li"
 },
 {
  "i": 8,
  "q": 3,
  "x": 1105,
  "y": 297,
  "location": "38M",
  "key": "T38M"
 },
 {
  "i": 8,
  "q": 3,
  "x": 1120,
  "y": 312,
  "location": "38B",
  "key": "T38B"
 },
 {
  "i": 8,
  "q": 3,
  "x": 1135,
  "y": 297,
  "location": "38D",
  "key": "T38D"
 },
 {
  "i": 8,
  "q": 3,
  "x": 1120,
  "y": 297,
  "location": "38O",
  "key": "T38O"
 },
 {
  "i": 8,
  "q": 3,
  "x": 1087,
  "y": 297,
  "location": "S37S38",
  "key": "TS37S38"
 },
 {
  "i": 8,
  "q": 3,
  "x": 1120,
  "y": 330,
  "location": "S38B",
  "key": "TS38B"
 },
 {
  "i": 8,
  "q": 3,
  "x": 1120,
  "y": 264,
  "location": "S38Li",
  "key": "TS38Li"
 },
 {
  "i": 8,
  "q": 3,
  "x": 1153,
  "y": 297,
  "location": "S38D",
  "key": "TS38D"
 },
 {
  "i": 1,
  "q": 4,
  "x": 535,
  "y": 282,
  "location": "41Li",
  "key": "T41Li"
 },
 {
  "i": 1,
  "q": 4,
  "x": 520,
  "y": 297,
  "location": "41D",
  "key": "T41D"
 },
 {
  "i": 1,
  "q": 4,
  "x": 535,
  "y": 312,
  "location": "41La",
  "key": "T41La"
 },
 {
  "i": 1,
  "q": 4,
  "x": 550,
  "y": 297,
  "location": "41M",
  "key": "T41M"
 },
 {
  "i": 1,
  "q": 4,
  "x": 535,
  "y": 297,
  "location": "41I",
  "key": "T41I"
 },
 {
  "i": 1,
  "q": 4,
  "x": 502,
  "y": 297,
  "location": "S41S42",
  "key": "TS41S42"
 },
 {
  "i": 1,
  "q": 4,
  "x": 535,
  "y": 330,
  "location": "S41La",
  "key": "TS41La"
 },
 {
  "i": 1,
  "q": 4,
  "x": 535,
  "y": 264,
  "location": "S41Li",
  "key": "TS41Li"
 },
 {
  "i": 2,
  "q": 4,
  "x": 470,
  "y": 282,
  "location": "42Li",
  "key": "T42Li"
 },
 {
  "i": 2,
  "q": 4,
  "x": 455,
  "y": 297,
  "location": "42D",
  "key": "T42D"
 },
 {
  "i": 2,
  "q": 4,
  "x": 470,
  "y": 312,
  "location": "42La",
  "key": "T42La"
 },
 {
  "i": 2,
  "q": 4,
  "x": 485,
  "y": 297,
  "location": "42M",
  "key": "T42M"
 },
 {
  "i": 2,
  "q": 4,
  "x": 470,
  "y": 297,
  "location": "42I",
  "key": "T42I"
 },
 {
  "i": 2,
  "q": 4,
  "x": 437,
  "y": 297,
  "location": "S42S43",
  "key": "TS42S43"
 },
 {
  "i": 2,
  "q": 4,
  "x": 470,
  "y": 330,
  "location": "S42La",
  "key": "TS42La"
 },
 {
  "i": 2,
  "q": 4,
  "x": 470,
  "y": 264,
  "location": "S42Li",
  "key": "TS42Li"
 },
 {
  "i": 3,
  "q": 4,
  "x": 405,
  "y": 282,
  "location": "43Li",
  "key": "T43Li"
 },
 {
  "i": 3,
  "q": 4,
  "x": 390,
  "y": 297,
  "location": "43D",
  "key": "T43D"
 },
 {
  "i": 3,
  "q": 4,
  "x": 405,
  "y": 312,
  "location": "43La",
  "key": "T43La"
 },
 {
  "i": 3,
  "q": 4,
  "x": 420,
  "y": 297,
  "location": "43M",
  "key": "T43M"
 },
 {
  "i": 3,
  "q": 4,
  "x": 405,
  "y": 297,
  "location": "43I",
  "key": "T43I"
 },
 {
  "i": 3,
  "q": 4,
  "x": 372,
  "y": 297,
  "location": "S43S44",
  "key": "TS43S44"
 },
 {
  "i": 3,
  "q": 4,
  "x": 405,
  "y": 330,
  "location": "S43La",
  "key": "TS43La"
 },
 {
  "i": 3,
  "q": 4,
  "x": 405,
  "y": 264,
  "location": "S43Li",
  "key": "TS43Li"
 },
 {
  "i": 4,
  "q": 4,
  "x": 340,
  "y": 282,
  "location": "44Li",
  "key": "T44Li"
 },
 {
  "i": 4,
  "q": 4,
  "x": 325,
  "y": 297,
  "location": "44D",
  "key": "T44D"
 },
 {
  "i": 4,
  "q": 4,
  "x": 340,
  "y": 312,
  "location": "44B",
  "key": "T44B"
 },
 {
  "i": 4,
  "q": 4,
  "x": 355,
  "y": 297,
  "location": "44M",
  "key": "T44M"
 },
 {
  "i": 4,
  "q": 4,
  "x": 340,
  "y": 297,
  "location": "44O",
  "key": "T44O"
 },
 {
  "i": 4,
  "q": 4,
  "x": 307,
  "y": 297,
  "location": "S44S45",
  "key": "TS44S45"
 },
 {
  "i": 4,
  "q": 4,
  "x": 340,
  "y": 330,
  "location": "S44B",
  "key": "TS44B"
 },
 {
  "i": 4,
  "q": 4,
  "x": 340,
  "y": 264,
  "location": "S44Li",
  "key": "TS44Li"
 },
 {
  "i": 5,
  "q": 4,
  "x": 275,
  "y": 282,
  "location": "45Li",
  "key": "T45Li"
 },
 {
  "i": 5,
  "q": 4,
  "x": 260,
  "y": 297,
  "location": "45D",
  "key": "T45D"
 },
 {
  "i": 5,
  "q": 4,
  "x": 275,
  "y": 312,
  "location": "45B",
  "key": "T45B"
 },
 {
  "i": 5,
  "q": 4,
  "x": 290,
  "y": 297,
  "location": "45M",
  "key": "T45M"
 },
 {
  "i": 5,
  "q": 4,
  "x": 275,
  "y": 297,
  "location": "45O",
  "key": "T45O"
 },
 {
  "i": 5,
  "q": 4,
  "x": 242,
  "y": 297,
  "location": "S45S46",
  "key": "TS45S46"
 },
 {
  "i": 5,
  "q": 4,
  "x": 275,
  "y": 330,
  "location": "S45B",
  "key": "TS45B"
 },
 {
  "i": 5,
  "q": 4,
  "x": 275,
  "y": 264,
  "location": "S45Li",
  "key": "TS45Li"
 },
 {
  "i": 6,
  "q": 4,
  "x": 210,
  "y": 282,
  "location": "46Li",
  "key": "T46Li"
 },
 {
  "i": 6,
  "q": 4,
  "x": 195,
  "y": 297,
  "location": "46D",
  "key": "T46D"
 },
 {
  "i": 6,
  "q": 4,
  "x": 210,
  "y": 312,
  "location": "46B",
  "key": "T46B"
 },
 {
  "i": 6,
  "q": 4,
  "x": 225,
  "y": 297,
  "location": "46M",
  "key": "T46M"
 },
 {
  "i": 6,
  "q": 4,
  "x": 210,
  "y": 297,
  "location": "46O",
  "key": "T46O"
 },
 {
  "i": 6,
  "q": 4,
  "x": 177,
  "y": 297,
  "location": "S46S47",
  "key": "TS46S47"
 },
 {
  "i": 6,
  "q": 4,
  "x": 210,
  "y": 330,
  "location": "S46B",
  "key": "TS46B"
 },
 {
  "i": 6,
  "q": 4,
  "x": 210,
  "y": 264,
  "location": "S46Li",
  "key": "TS46Li"
 },
 {
  "i": 7,
  "q": 4,
  "x": 145,
  "y": 282,
  "location": "47Li",
  "key": "T47Li"
 },
 {
  "i": 7,
  "q": 4,
  "x": 130,
  "y": 297,
  "location": "47D",
  "key": "T47D"
 },
 {
  "i": 7,
  "q": 4,
  "x": 145,
  "y": 312,
  "location": "47B",
  "key": "T47B"
 },
 {
  "i": 7,
  "q": 4,
  "x": 160,
  "y": 297,
  "location": "47M",
  "key": "T47M"
 },
 {
  "i": 7,
  "q": 4,
  "x": 145,
  "y": 297,
  "location": "47O",
  "key": "T47O"
 },
 {
  "i": 7,
  "q": 4,
  "x": 112,
  "y": 297,
  "location": "S47S48",
  "key": "TS47S48"
 },
 {
  "i": 7,
  "q": 4,
  "x": 145,
  "y": 330,
  "location": "S47B",
  "key": "TS47B"
 },
 {
  "i": 7,
  "q": 4,
  "x": 145,
  "y": 264,
  "location": "S47Li",
  "key": "TS47Li"
 },
 {
  "i": 8,
  "q": 4,
  "x": 80,
  "y": 282,
  "location": "48Li",
  "key": "T48Li"
 },
 {
  "i": 8,
  "q": 4,
  "x": 65,
  "y": 297,
  "location": "48D",
  "key": "T48D"
 },
 {
  "i": 8,
  "q": 4,
  "x": 80,
  "y": 312,
  "location": "48B",
  "key": "T48B"
 },
 {
  "i": 8,
  "q": 4,
  "x": 95,
  "y": 297,
  "location": "48M",
  "key": "T48M"
 },
 {
  "i": 8,
  "q": 4,
  "x": 80,
  "y": 297,
  "location": "48O",
  "key": "T48O"
 },
 {
  "i": 8,
  "q": 4,
  "x": 47,
  "y": 297,
  "location": "S48D",
  "key": "TS48D"
 },
 {
  "i": 8,
  "q": 4,
  "x": 80,
  "y": 330,
  "location": "S48B",
  "key": "TS48B"
 },
 {
  "i": 8,
  "q": 4,
  "x": 80,
  "y": 264,
  "location": "S48Li",
  "key": "TS48Li"
 },
 {
  "i": 1,
  "q": 5,
  "x": 535,
  "y": 119,
  "location": "51La",
  "key": "T51La"
 },
 {
  "i": 1,
  "q": 5,
  "x": 520,
  "y": 134,
  "location": "51D",
  "key": "T51D"
 },
 {
  "i": 1,
  "q": 5,
  "x": 535,
  "y": 149,
  "location": "51Pa",
  "key": "T51Pa"
 },
 {
  "i": 1,
  "q": 5,
  "x": 550,
  "y": 134,
  "location": "51M",
  "key": "T51M"
 },
 {
  "i": 1,
  "q": 5,
  "x": 535,
  "y": 134,
  "location": "51I",
  "key": "T51I"
 },
 {
  "i": 2,
  "q": 5,
  "x": 470,
  "y": 119,
  "location": "52La",
  "key": "T52La"
 },
 {
  "i": 2,
  "q": 5,
  "x": 455,
  "y": 134,
  "location": "52D",
  "key": "T52D"
 },
 {
  "i": 2,
  "q": 5,
  "x": 470,
  "y": 149,
  "location": "52Pa",
  "key": "T52Pa"
 },
 {
  "i": 2,
  "q": 5,
  "x": 485,
  "y": 134,
  "location": "52M",
  "key": "T52M"
 },
 {
  "i": 2,
  "q": 5,
  "x": 470,
  "y": 134,
  "location": "52I",
  "key": "T52I"
 },
 {
  "i": 3,
  "q": 5,
  "x": 405,
  "y": 119,
  "location": "53La",
  "key": "T53La"
 },
 {
  "i": 3,
  "q": 5,
  "x": 390,
  "y": 134,
  "location": "53D",
  "key": "T53D"
 },
 {
  "i": 3,
  "q": 5,
  "x": 405,
  "y": 149,
  "location": "53Pa",
  "key": "T53Pa"
 },
 {
  "i": 3,
  "q": 5,
  "x": 420,
  "y": 134,
  "location": "53M",
  "key": "T53M"
 },
 {
  "i": 3,
  "q": 5,
  "x": 405,
  "y": 134,
  "location": "53I",
  "key": "T53I"
 },
 {
  "i": 4,
  "q": 5,
  "x": 340,
  "y": 119,
  "location": "54B",
  "key": "T54B"
 },
 {
  "i": 4,
  "q": 5,
  "x": 325,
  "y": 134,
  "location": "54D",
  "key": "T54D"
 },
 {
  "i": 4,
  "q": 5,
  "x": 340,
  "y": 149,
  "location": "54Pa",
  "key": "T54Pa"
 },
 {
  "i": 4,
  "q": 5,
  "x": 355,
  "y": 134,
  "location": "54M",
  "key": "T54M"
 },
 {
  "i": 4,
  "q": 5,
  "x": 340,
  "y": 134,
  "location": "54O",
  "key": "T54O"
 },
 {
  "i": 5,
  "q": 5,
  "x": 275,
  "y": 119,
  "location": "55B",
  "key": "T55B"
 },
 {
  "i": 5,
  "q": 5,
  "x": 260,
  "y": 134,
  "location": "55D",
  "key": "T55D"
 },
 {
  "i": 5,
  "q": 5,
  "x": 275,
  "y": 149,
  "location": "55Pa",
  "key": "T55Pa"
 },
 {
  "i": 5,
  "q": 5,
  "x": 290,
  "y": 134,
  "location": "55M",
  "key": "T55M"
 },
 {
  "i": 5,
  "q": 5,
  "x": 275,
  "y": 134,
  "location": "55O",
  "key": "T55O"
 },
 {
  "i": 1,
  "q": 6,
  "x": 665,
  "y": 119,
  "location": "61La",
  "key": "T61La"
 },
 {
  "i": 1,
  "q": 6,
  "x": 650,
  "y": 134,
  "location": "61M",
  "key": "T61M"
 },
 {
  "i": 1,
  "q": 6,
  "x": 665,
  "y": 149,
  "location": "61Pa",
  "key": "T61Pa"
 },
 {
  "i": 1,
  "q": 6,
  "x": 680,
  "y": 134,
  "location": "61D",
  "key": "T61D"
 },
 {
  "i": 1,
  "q": 6,
  "x": 665,
  "y": 134,
  "location": "61I",
  "key": "T61I"
 },
 {
  "i": 2,
  "q": 6,
  "x": 730,
  "y": 119,
  "location": "62La",
  "key": "T62La"
 },
 {
  "i": 2,
  "q": 6,
  "x": 715,
  "y": 134,
  "location": "62M",
  "key": "T62M"
 },
 {
  "i": 2,
  "q": 6,
  "x": 730,
  "y": 149,
  "location": "62Pa",
  "key": "T62Pa"
 },
 {
  "i": 2,
  "q": 6,
  "x": 745,
  "y": 134,
  "location": "62D",
  "key": "T62D"
 },
 {
  "i": 2,
  "q": 6,
  "x": 730,
  "y": 134,
  "location": "62I",
  "key": "T62I"
 },
 {
  "i": 3,
  "q": 6,
  "x": 795,
  "y": 119,
  "location": "63La",
  "key": "T63La"
 },
 {
  "i": 3,
  "q": 6,
  "x": 780,
  "y": 134,
  "location": "63M",
  "key": "T63M"
 },
 {
  "i": 3,
  "q": 6,
  "x": 795,
  "y": 149,
  "location": "63Pa",
  "key": "T63Pa"
 },
 {
  "i": 3,
  "q": 6,
  "x": 810,
  "y": 134,
  "location": "63D",
  "key": "T63D"
 },
 {
  "i": 3,
  "q": 6,
  "x": 795,
  "y": 134,
  "location": "63I",
  "key": "T63I"
 },
 {
  "i": 4,
  "q": 6,
  "x": 860,
  "y": 119,
  "location": "64B",
  "key": "T64B"
 },
 {
  "i": 4,
  "q": 6,
  "x": 845,
  "y": 134,
  "location": "64M",
  "key": "T64M"
 },
 {
  "i": 4,
  "q": 6,
  "x": 860,
  "y": 149,
  "location": "64Pa",
  "key": "T64Pa"
 },
 {
  "i": 4,
  "q": 6,
  "x": 875,
  "y": 134,
  "location": "64D",
  "key": "T64D"
 },
 {
  "i": 4,
  "q": 6,
  "x": 860,
  "y": 134,
  "location": "64O",
  "key": "T64O"
 },
 {
  "i": 5,
  "q": 6,
  "x": 925,
  "y": 119,
  "location": "65B",
  "key": "T65B"
 },
 {
  "i": 5,
  "q": 6,
  "x": 910,
  "y": 134,
  "location": "65M",
  "key": "T65M"
 },
 {
  "i": 5,
  "q": 6,
  "x": 925,
  "y": 149,
  "location": "65Pa",
  "key": "T65Pa"
 },
 {
  "i": 5,
  "q": 6,
  "x": 940,
  "y": 134,
  "location": "65D",
  "key": "T65D"
 },
 {
  "i": 5,
  "q": 6,
  "x": 925,
  "y": 134,
  "location": "65O",
  "key": "T65O"
 },
 {
  "i": 1,
  "q": 7,
  "x": 665,
  "y": 198,
  "location": "71Li",
  "key": "T71Li"
 },
 {
  "i": 1,
  "q": 7,
  "x": 650,
  "y": 213,
  "location": "71M",
  "key": "T71M"
 },
 {
  "i": 1,
  "q": 7,
  "x": 665,
  "y": 228,
  "location": "71La",
  "key": "T71La"
 },
 {
  "i": 1,
  "q": 7,
  "x": 680,
  "y": 213,
  "location": "71D",
  "key": "T71D"
 },
 {
  "i": 1,
  "q": 7,
  "x": 665,
  "y": 213,
  "location": "71I",
  "key": "T71I"
 },
 {
  "i": 2,
  "q": 7,
  "x": 730,
  "y": 198,
  "location": "72Li",
  "key": "T72Li"
 },
 {
  "i": 2,
  "q": 7,
  "x": 715,
  "y": 213,
  "location": "72M",
  "key": "T72M"
 },
 {
  "i": 2,
  "q": 7,
  "x": 730,
  "y": 228,
  "location": "72La",
  "key": "T72La"
 },
 {
  "i": 2,
  "q": 7,
  "x": 745,
  "y": 213,
  "location": "72D",
  "key": "T72D"
 },
 {
  "i": 2,
  "q": 7,
  "x": 730,
  "y": 213,
  "location": "72I",
  "key": "T72I"
 },
 {
  "i": 3,
  "q": 7,
  "x": 795,
  "y": 198,
  "location": "73Li",
  "key": "T73Li"
 },
 {
  "i": 3,
  "q": 7,
  "x": 780,
  "y": 213,
  "location": "73M",
  "key": "T73M"
 },
 {
  "i": 3,
  "q": 7,
  "x": 795,
  "y": 228,
  "location": "73La",
  "key": "T73La"
 },
 {
  "i": 3,
  "q": 7,
  "x": 810,
  "y": 213,
  "location": "73D",
  "key": "T73D"
 },
 {
  "i": 3,
  "q": 7,
  "x": 795,
  "y": 213,
  "location": "73I",
  "key": "T73I"
 },
 {
  "i": 4,
  "q": 7,
  "x": 860,
  "y": 198,
  "location": "74Li",
  "key": "T74Li"
 },
 {
  "i": 4,
  "q": 7,
  "x": 845,
  "y": 213,
  "location": "74M",
  "key": "T74M"
 },
 {
  "i": 4,
  "q": 7,
  "x": 860,
  "y": 228,
  "location": "74B",
  "key": "T74B"
 },
 {
  "i": 4,
  "q": 7,
  "x": 875,
  "y": 213,
  "location": "74D",
  "key": "T74D"
 },
 {
  "i": 4,
  "q": 7,
  "x": 860,
  "y": 213,
  "location": "74O",
  "key": "T74O"
 },
 {
  "i": 5,
  "q": 7,
  "x": 925,
  "y": 198,
  "location": "75Li",
  "key": "T75Li"
 },
 {
  "i": 5,
  "q": 7,
  "x": 910,
  "y": 213,
  "location": "75M",
  "key": "T75M"
 },
 {
  "i": 5,
  "q": 7,
  "x": 925,
  "y": 228,
  "location": "75B",
  "key": "T75B"
 },
 {
  "i": 5,
  "q": 7,
  "x": 940,
  "y": 213,
  "location": "75D",
  "key": "T75D"
 },
 {
  "i": 5,
  "q": 7,
  "x": 925,
  "y": 213,
  "location": "75O",
  "key": "T75O"
 },
 {
  "i": 1,
  "q": 8,
  "x": 535,
  "y": 198,
  "location": "81Li",
  "key": "T81Li"
 },
 {
  "i": 1,
  "q": 8,
  "x": 520,
  "y": 213,
  "location": "81D",
  "key": "T81D"
 },
 {
  "i": 1,
  "q": 8,
  "x": 535,
  "y": 228,
  "location": "81La",
  "key": "T81La"
 },
 {
  "i": 1,
  "q": 8,
  "x": 550,
  "y": 213,
  "location": "81M",
  "key": "T81M"
 },
 {
  "i": 1,
  "q": 8,
  "x": 535,
  "y": 213,
  "location": "81I",
  "key": "T81I"
 },
 {
  "i": 2,
  "q": 8,
  "x": 470,
  "y": 198,
  "location": "82Li",
  "key": "T82Li"
 },
 {
  "i": 2,
  "q": 8,
  "x": 455,
  "y": 213,
  "location": "82D",
  "key": "T82D"
 },
 {
  "i": 2,
  "q": 8,
  "x": 470,
  "y": 228,
  "location": "82La",
  "key": "T82La"
 },
 {
  "i": 2,
  "q": 8,
  "x": 485,
  "y": 213,
  "location": "82M",
  "key": "T82M"
 },
 {
  "i": 2,
  "q": 8,
  "x": 470,
  "y": 213,
  "location": "82I",
  "key": "T82I"
 },
 {
  "i": 3,
  "q": 8,
  "x": 405,
  "y": 198,
  "location": "83Li",
  "key": "T83Li"
 },
 {
  "i": 3,
  "q": 8,
  "x": 390,
  "y": 213,
  "location": "83D",
  "key": "T83D"
 },
 {
  "i": 3,
  "q": 8,
  "x": 405,
  "y": 228,
  "location": "83La",
  "key": "T83La"
 },
 {
  "i": 3,
  "q": 8,
  "x": 420,
  "y": 213,
  "location": "83M",
  "key": "T83M"
 },
 {
  "i": 3,
  "q": 8,
  "x": 405,
  "y": 213,
  "location": "83I",
  "key": "T83I"
 },
 {
  "i": 4,
  "q": 8,
  "x": 340,
  "y": 198,
  "location": "84Li",
  "key": "T84Li"
 },
 {
  "i": 4,
  "q": 8,
  "x": 325,
  "y": 213,
  "location": "84D",
  "key": "T84D"
 },
 {
  "i": 4,
  "q": 8,
  "x": 340,
  "y": 228,
  "location": "84B",
  "key": "T84B"
 },
 {
  "i": 4,
  "q": 8,
  "x": 355,
  "y": 213,
  "location": "84M",
  "key": "T84M"
 },
 {
  "i": 4,
  "q": 8,
  "x": 340,
  "y": 213,
  "location": "84O",
  "key": "T84O"
 },
 {
  "i": 5,
  "q": 8,
  "x": 275,
  "y": 198,
  "location": "85Li",
  "key": "T85Li"
 },
 {
  "i": 5,
  "q": 8,
  "x": 260,
  "y": 213,
  "location": "85D",
  "key": "T85D"
 },
 {
  "i": 5,
  "q": 8,
  "x": 275,
  "y": 228,
  "location": "85B",
  "key": "T85B"
 },
 {
  "i": 5,
  "q": 8,
  "x": 290,
  "y": 213,
  "location": "85M",
  "key": "T85M"
 },
 {
  "i": 5,
  "q": 8,
  "x": 275,
  "y": 213,
  "location": "85O",
  "key": "T85O"
 }
]